// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../js/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../js/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../js/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("stop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("conf2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("squo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("zoom.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("dnah.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("hand.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("loader.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("chat.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("flag-d.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("warn.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("okay.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("bar0.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("bar1.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("rado.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("radx.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("star.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Noto+Sans:400italic,700italic,400,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Noto+Sans+Symbols:400italic,700italic,400,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Noto+Nastaliq+Urdu);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Sunuwar&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Copyright (c) 2004-2013 IBM and others. All Rights Reserved. */
/* Made with CSSEdit and Espresso2 */
@charset "UTF-8";

/* TODO: should load this locally via webpack, see https://unicode-org.atlassian.net/browse/CLDR-9195 */

span.age  {
	font-weight: bold;
	font-style: italic;
}

ul.adminList  {
	display:  table-row;
	border: 1px solid gray;
}

ul.adminList li {
	display:  table-cell;
	padding:  0.5em;
}

ul.adminList li.selected {
	border-left:  1px solid gray;
	border-right:  3px solid gray;
	border-top:  1px solid gray;
	background-color: whitesmoke;
	box-shadow: 3px 0px 5px gray;
}

ul.adminList li.notselected {
	background-color: #eee;
	border-left:  1px solid #ddd;
	border-right:  1px solid #ddd;
}

.transcript-container {
	display: none;
}

.transcript-container.visible {
	display: block;
}

a.show-transcript {
	float: right;
}

pre.transcript-text {
	font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
	font-size: small;
	white-space: pre-line;
	word-break: normal;
}

#small_login_shower button {
    float:  right;
}

div.adminPanel {
	border:  1px solid gray;
	box-shadow: 3px 3px 5px gray;
	padding:  2px;
}

h3.adminTitle {
	font-size: x-large;
	border-bottom:  2px solid black;
}
.userlist .seenSub::before {
    content: 'Activity';
    font-size: xx-small;
}
.userlist .seenSub {
    display: block;
    margin-top:  0.5em;
}

.userlist .seenSub .chartRow{
    display:  table-row;
}
.userlist .seenSub .chartRow span{
    display:  table-cell;
    font-size: small;
    padding-right: 0.25em;
}

.seenSub .chartDay {
    white-space: nowrap;
}
.seenSub .chartLoc {
    font-family: "Courier New", Courier, mono;
}
.seenSub .chartCount {
    font-family: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
    text-align: right;
}

.userlist .chartMore {
    float: right;
    border: 1px solid black;
    padding:  2px;
    margin:  1px;
    background-color: silver;
    display: run-in;
}

.userlist div.adminUserUser {
    padding: 0;
    margin: 0;
}

div.adminUserUser i {
	font-weight: normal;
	font-style: normal;
	font-variant: small-caps;
	float:  right;
	color: white;
	background-color: black;
	margin:  0.5em;
	padding:  3px;
}

.adminUserUser img {
    margin-top:  0.25em;
    margin-left:  0.25em;
    margin-right:  0.25em;
    float: left;
}

.adminSettingsList {
	display: table;
	width: 100%;
}

.adminSetting {
    display: table-row;
    background-color: #fcf8e3;
}

.adminSetting input {
	width: 90%;
	display: block;
}

.adminSetting label {
	font-size: small;
}

#specialHeader {
	display: block;
    padding: 0.25em;
    color:  black;
    background-color: #fcf8e3;
    opacity: 1;
	font: italic  small Georgia, "Times New Roman", Times, serif;
	margin-top:  2px;
	box-shadow: 1px 1px 1px gray;
}
.adminSettingId, .adminSettingValue {
    display: table-cell;
    padding:  2px;
    border-bottom:  1px dashed gray;
}

.adminSettingId {
	font-weight: bold;
	padding-right: 1em;
}

.adminSettingValue {
	padding-bottom:  1px;
	font-family: "Courier New", Courier, mono;
	font-size:  small;
}

.debugStuff {
	font-family: monospace,"Courier New", Courier, mono;
	font-size:  small;
	padding:  0.25em;
	background-color:  white;
	border:  3px groove green;
	box-shadow: 3px 3px 2px gray;
}

.userlist .noActivity a.recentActivity {
    opacity:  0.5;
}

.userlist .hadActivity a.recentActivity {
    font-weight: bold;
    opacity:  1.0;
    color:  white;
    background-color:  navy;
}

.userlist  .noActivity .adminUserUser {
    opacity:  0.75;
}
.userlist  .hadActivity .adminUserUser {
    border:  2px solid black;
}

i.userlevel_guest {
	background-color: navy !important;
	color:  white !important;
}
i.userlevel_vetter {
	background-color: green !important;
	color:  black !important;
}
i.userlevel_locked {
	background-color: gray !important;
	color:  silver !important;
}
i.userlevel_manager{
	background-color: #e77de7 !important;
	color: white !important;
}
i.userlevel_admin {
	background-color: maroon !important;
	color:  silver !important;
}
i.userlevel_tc {
	background-color: orange !important;
	color:  black !important;
}


/* todo: replace w/ icons */


div.adminUser {
	margin:  1em;
	border:  1px solid gray ;
	width:  50em;
	background-color: #e3e3e3;
}

span.adminUserSession {
	font: small Georgia, "Times New Roman", Times, serif;
	text-align: left;
	float: right;
}

span.adminUserInfo {
	font-size: small;
	text-align: right;
	margin:  8px;
}


div.adminUserUser {
	background-color: #92c1c9;
	width:  30em;
	margin:  1em;
}

div.forumDiv div.adminUserUser {
    width:  inherit !important;
}

span.adminUserName {
	font-size:  large;
	display:  block;
}
span.adminOrgName {
	font-size: small;
	display:  block;
    font-style: italic;
}

address.adminUserAddress {
	font: normal smaller "Courier New", Courier, mono;
    white-space: nowrap;
}



button.icancel {
	display: none;
}

button.isubmit {


}

button.ichoice {

}

button.inochoice {

}

#explainIcons {
	font-size: small;
}

/* @group Vetting View */

/* todo: sync with later items */

table.tv-table, table.tvs-table {
	border-collapse: collapse;
}

table.tv-table, th.tv-th, tr.tv-tr, td.tv-num, td.tv-code, td.tv-eng, td.tv-last, td.tv-win, td.tv-fix, table.tvs-table, tr.tvs-tr, td.tvs-count, td.tvs-abb, td.tvs-desc, td.tv-test {
	border: 1px solid gray;
}

td.tv-num, td.tv-code, td.tv-eng, td.tv-last, td.tv-win, td.tv-fix, td.tvs-count, td.tvs-abb, td.tvs-desc {
	background-color: #FFFFCC;
}

td.tv-num, td.tvs-count {
	text-align: right;
}

th.tv-th, th.tvs-th {
	background-color: #DDDDDD;
}

th.tv-win {
	background-color: #FFCCCC;
}

/* @end */

td {
	vertical-align: top;
}

hr {
	border: 1px dashed #ccd
}

tr.row0 {
	background-color: #fff
}

tr.row1 {
	background-color: #ddd
}

A.nodraft {
	text-decoration: none
}

A.nodraft:link {
	color: #4567b0
}

A.nodraft:active {
	color: #f00
}

A.nodraft:visited {
	color: #8372d2
}

.draftl {
	font-weight: bold;
	text-decoration: none
}

.missing {
	background-color: #ffd8c8;
	border: 1px solid red;
}

.missing a:link {
	color: #fff
}

.missing a:visited {
	color: #ddd
}

.missing a:active {
	color: #f00
}

.missing a:hover {
	color: #fDD
}

.xpath {
	font-size: smaller;
}

div.search div.results h3, div.search div.results h4 {
    display:  inline;
    padding-right:  2em;
}

div.search div.results li {
    display:  block;
}

div.search a.xpath {
    display: block;
    color:  gray;
}

div.search div.results li {
    border-top:  1px solid silver;
    list-style: none;
    padding-bottom: 0.5em;
}

div.search div.results li a.codebox {
    font-size:  larger;
}

.alias {
 background-color: #ddf;
}

.constructed {
	background-color: sandybrown;
	padding: .1em .4em .2em;
	border-style: groove;
}

.fallback {
	background-color:#5bc0de;
	padding: .1em .4em .2em;

}
.fallback_root, .fallback_code {
	border: 1px dotted #f00 !important;
	background-color: #FFDDDD ;
}

.draft {
	background-color: #88FFAA  !important;
}

.proposed {
	background-color: #88DDAA  !important;
}

.selected {
	font-size: 120%;
	font-weight: bold;
	color: #313998;
}

a.selected :link {
	color: #fff
}

.notselected {
	margin: 2px;
	padding: 1px;
}

a.notselected {
	color: #358cc3;
	text-decoration: underline;
}

div.adminThreads {
	display:  table;
}

div.adminThreadList,
div.adminExceptionList {
	width:  43%;
	clear:  right;
	padding-right:  1em;
	display:  table;
}

.adminExceptionFooter {
	padding: 0.25em;
	font-style: oblique;
	display: block;
	clear: both;
	padding-bottom: 0.5em;
	float: right;
}

div.adminThreadList span {
	display:  table-cell;
}

span.adminExceptionHeader {
	font-weight: bold;
	font-family: Georgia, "Times New Roman", Times, serif;
	display:  block;
}

span.adminExceptionUptime {
	display: block;
	color: darkgreen;
	font-family: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
}

#adminStuff div.adminPanel div.adminThreads div.adminThreadStack pre.adminExceptionSTACK {
	padding-left:  2em;
	padding-top: 0;
	margin-top: 0;
}

.deadThread, .adminDeadThreadsHeader, ul.adminDeadThreads {
    background-color: red;
    color: black;
}
.adminDeadThreadsHeader {
    padding-left: 30px;
    margin:0;
    white-space: nowrap;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 top;
    display: block;
}

ul.adminDeadThreads {
    display: inline;
    padding-left: 40px;
    margin:0;
    margin-bottom: 1em;
}

ul.adminDeadThreads li {
    display: inline;
    padding-left: 0.25em;
}

.adminThreadStack {
    vertical-align: top;
}

pre.adminExceptionLogsite {
    padding-left:  20px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 0 top;
}

pre.adminExceptionSQL {
	padding-left:  20px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 0 top;
	font: italic bold large "Courier New", Courier, mono;
}

pre.adminExceptionMESSAGE {
	white-space: normal;
	border-top: 2px solid gray;
	font-weight: bold;
	font-family: Georgia, "Times New Roman", Times, serif;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 top;
	padding-left:   20px;
	padding-bottom: 0;
	margin-bottom: 0;
}

div.adminException {
	display: block;
	padding-top:  0.25em;
	padding-bottom:  1.5em;
	border-bottom:  1px solid whitesmoke;
}

div.adminException span {
	display:  block;
}

div.adminException span.adminExceptionHeader {
	display:  block;
	padding-left:  20px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 top;
}

span.adminExceptionDate {
	white-space: nowrap;
	font: small "Lucida Grande", Lucida, Verdana, sans-serif;
	float: right;
	display: block
}

span.adminThreadse_RUNNABLE {
	background-color: lime;
}

span.adminThreadState_WAITING {
	background-color: lightgreen;
}
span.adminThreadState_BLOCKED {
	background-color: red;
}
span.adminThreadState_TIMED_WAITING {
	background-color: silver;
}

.adminExceptionCount {
	padding-left:  20px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat 0 top;
	text-decoration: underline;
}

.adminExceptionMore {
	color: maroon;
}

.adminExceptionCount:hover,
div.adminException span.adminExceptionHeader:hover {
	color: blue;
}

div.adminThread {
	border-bottom:  1px dotted gray;
	display:  table-row;
	padding-right: 0.5em;
}


span.adminThreadId {
	width:  5em;
	padding-right:  1em;
}

span.adminThreadName {
	border-bottom: 1px solid silver;
}

span.adminThreadState_RUNNABLE,
span.adminThreadState_TIMED_WAITING,
span.adminThreadState_WAITING,
span.adminThreadState_BLOCKED {
	text-align: right;
	font-size: small;
	font-weight: bold;
}

div.adminThreadStack {
	display:  inline;
	white-space: pre;
	width: 43%;
	display:  table-cell;
	font: small "Courier New", Courier, mono;
	background-color: #fcf8e3;
	padding:  3px;
}

.textForTrac {
	background-color: #fcf8e3;
	color: #fcf8e3;
	font-size: 1px;
}

.clickToSelect {
	display: block;
	clear: both;
	float: right;
}

div.adminThreadStack b, span.adminThreadName {
	font-family: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
}

.sep {
	height: 3px;
	overflow: hidden;
	background-color: #44778C;
}

.name {
	background-color: #eef;
}

.warning {
	font-size: smaller;
	/*	font-color: #F22;
	*/
	color: #F22;
	background-color: #fee;
	border: 1px solid red;
}

.warningReference {
	font-family: "Lucida Grande", Lucida, Verdana, sans-serif;
	color: teal;
}

.warningTarget {
	font-family: "Lucida Grande", Lucida, Verdana, sans-serif;
	color: teal;
}

td.warncell {
	border-left: 1px solid #ddd;
}

tr.warnrow {
	/*    font-color: #f22;
	*/
    color: #f22;
	background-color: #fee;
}

.pager {
	border: 1px solid gray;
	background-color: #FFEECC;
	padding: 0.2em 0.2em 0.2em 0.2em;


/*	padding: 1em 1em 1em 1em; */
	margin-top: 2px;
	font-size: smaller;
}

.pagerln {
	border-bottom: 1px solid #aaa;
	border-top: 1px solid #aaa;
}

.pagerl_active {

}

.pagerl_inactive {
	color: gray;
}

.localenav {
	border: 1px solid gray;
	background-color: #fff;
	margin: 5px;
/*align: left;*/
}

.localeList {
    width:  auto;
}

.localeList .topLocaleRow {
    width:  auto;
}

.topLocale a {
    white-space: nowrap;
    font-weight: bold;
    font-size:  larger;
}

.localeList a:hover {
    color:  red !important;
}

.topLocaleRow .topLocaleDiv {
    display:  table-cell;
}
.topLocaleRow .subLocaleList {
    display:  block;
    padding-left:  4em;
}

.subLocaleList .subLocale {
    margin-right:  0.25em;
    display: inline-block;
}

.topLocaleRow a {
	display:block;
	padding-right: 12px;
	padding-top:6px;
	padding-bottom:6px;
	padding-left:5px;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -ms-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;
}

.topLocaleRow a:hover {
	background-color:#446e9b;
	color:white !important;
	text-decoration: none;
}

.scratch_locale a::after {
	content: " (TEST) ";
}

.subLocale a.locked.locName, .topLocaleRow a.locked.locName {
    color:  silver;
}

.canmodify::before {
	content:"\\270f  "; /* pencil */
	font-family: 'Glyphicons Halflings';
}

.locked::before {
    font-family:"Glyphicons Halflings";
    content:"\\e014 ";  /* X */
    margin-top:2px;
}

.name_var {
    font-style: oblique;
}

.inputbox {
	width: 95%;
}

.inputboxbig {
	width: 95%;
}

.badinputbox {
	border: 2px dashed red;
	width: 100%;
	height: 100%;
}

.hang {
	text-indent: -2em;
	padding-left: 2em;
	margin-bottom: .4em;
	margin-top: .4em;
}

.hangsml {
	text-indent: -1em;


/*

margin-left: 2em; */
}

table.list {
	border-collapse: collapse;
	display: inline;
}

table#statisticsTable {
    border-collapse: collapse;
}

#statistics_area {
	width: 80%;
	height: 400px;
/*    overflow: scroll;*/
	border: 1px solid gray;
	margin-bottom: 1em;
}

table#statisticsTable thead th {
    font-weight: bold;
    border-bottom: 1px solid gray
}

div.statistics h2 {
	border-top: 2px solid gray;
	width: 100%;
	margin-top: 2em;
}

div.statistics {
    margin-left: 1.5em;
}

div.dijitTooltipContainer.dijitTooltipContents {
    box-sizing: inherit !important;
}

div.statistics .swatch {
	border: 1px solid black;
	width: 1em;
	height: 1em;
	margin: 0.25em;
	white-space: pre;
}

div.statistics .color0 {
	background-color: #8aa717;
}

div.statistics .color1 {
	background-color: #1751a7;
}

table#statisticsTable td.locid {
    font: bold small "Courier New", Courier, mono;
    text-align: right;
}

table#statisticsTable a {
    text-decoration: none;
}

table#statisticsTable td.locname a,
table#statisticsTable td.selfname.dirltr a {
    padding-left:  18px;
}

table#statisticsTable td.selfname.dirrtl a {
    padding-right:  18px;
}


table#statisticsTable td.locname a:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
    text-decoration: underline;
}

table#statisticsTable td.selfname.dirltr a:hover
{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) left no-repeat;
    text-decoration: underline;
}
table#statisticsTable td.selfname.dirrtl a:hover
{
    background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) right no-repeat;
    text-decoration: underline;
}

table#statisticsTable .olddata {
    opacity: .8;
    color: #1561b7;
}

table#statisticsTable .olddata:hover {
    color: red;
}

table#statisticsTable tbody tr.r0 {

}
table#statisticsTable tbody tr.r1 {
    background-color: #d2eee1;
}

table#statisticsTable tbody tr:hover {
    background-color: #ecd290;
}

table#statisticsTable td.count {
    text-align: right;
}

div.minimenu {
	border-collapse: collapse;
	border-top: 1px solid black;
	background-color: #ddf;
}

div.minimenu a.forumlink {
	float: right;
}

h2.thisItem {
	margin-top: 0;
	font-family: Georgia;
	font-size: x-large;
	background-color: #ddf;
	text-align: center;
}

.small_login_hidden {
	display: none;
}

i.loadingMsg,
i.loadingMsgSpin {
	font-size: xx-large;
	text-align: justify;
	font-weight: bold;
	/* text-transform: uppercase; */
	color: black;
	font-style:normal;
}

i.loadingMsgSpin {
	white-space: pre;
	font-family: monospace;
}

/*
#LoadingMessageSection::after {
	content: url('loader.gif');
	position:relative;
	top:10px;
	left:15px;
}
*/


.loaderAnimIcon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-repeat: no-repeat;
	position:relative;
	top:10px;
	left:15px;
	width: 100px;
	height: 100px;
}

.small_login_hot {
	font-size: larger;
	border: 7px outset maroon;
	background-color: #fad084;
	padding: 2.0em;
	text-shadow: #000000 0 0 0;
	position: absolute;
	top: 25px;
	right: 0;
	z-index: 4;
	line-height: 1.34em;
}

.serverLoadInfo {
    margin-top:  5em;
    font: normal normal small "Lucida Grande", Lucida, Verdana, sans-serif;
}

div#smalllogin {

}

.small_login_visible {


/*opacity: 1;*/
	display: inline;
/*

visibility:  visible;*/
}

i.scary {
	color: #f9514d;
	font: normal normal x-small ocra10,Anaktoria;
}

.list.td .list.th {
	padding-top: 3px;
	padding-bottom: 4px;
}

.listb {
	border: 1px solid black;
	border-collapse: collapse
}

.listb.td .listb.th {
	padding-top: 3px;
	padding-bottom: 4px;
}

table.list tr.row0 {
	background-color: #fff
}

table.list tr.row1 {
	background-color: #edf3fe
}

table.list tr.heading {
	background-color: #dcfed2;
	color: #791830;
	border-bottom-style: solid;
	border-bottom-color: #c9c9c9;
}

table.userlist th {
	color: navy;
	font-size: 92%;
}

table.userlist td {
	text-align: left;
}

.user0 {
	border-color: maroon;
	border-color: maroon;
	color: maroon;
	background: #ffd3bb;
}

.userlist {
	border-collapse: collapse;
	text-align: left;
}

table.userlist {
	margin-top: 4px;
	margin-bottom: 4px;
	border-style: outset;
	text-align: left;
}

.voteDiv p {
	margin: 2px;
}

.topbar {
	border-top: 3px solid #040;
}

.botbar {
	border-bottom: 3px solid #040;
}

th.botgray {
	border-bottom: 1px solid #ddd;
}

td.botgray {
	border-bottom: 1px solid #ddd;
}

td.topgray {
	border-top: 1px solid #ddd;
}

tr.warningRow td {
	border-top: 1px solid #222;
	border-bottom: 1px solid #222;
}

tr.referenceRow td {
	border-top: 1px solid #222;
	border-bottom: 1px solid #222;
}

tr.heading {
	background: #ddd;
}

tr.heading th.partsection {
	border-top: 2px solid black;
	z-index: 0;
}

th.partsection {
	border-top: 2px solid gray;
	padding: 0.5em;
}

.userlist th.partsection {
	border-top: 2px solid gray !important;
	padding: 0.5em !important;
	background: silver;
}
.userlist th.partsection  h4{
	margin: 0;
}

th.partsection, th.partsection a {
	font-weight: bold;
	font-style: italic;
	background-color: #d9edf7;
	color: #111111;
	text-align: left;
	z-index: 0;
    text-transform: capitalize;
}

tt.codebox {
	border: 1px solid gray;
}

.respbox {
	border: 1px solid gray;
	padding: 0.5em;
}

div.respbox:target {
	border: 4px solid goldenrod !important;
	padding: 1em;
}

.respbox h3, .respbox h3 a {
	color: #084610;
	margin: 2px;
}

.person {
	float: right;
	clear: none;
	font-size: smaller;
	text-align: right;
}

div.person a {
	float: none;
}

.localeName {
    display:  block;
    font-size: medium;
}

.topicSubject {
    font-family: Georgia, "Times New Roman", Times, serif;
    font-weight:  bold;
}

.forum-me {
    font-weight:  bold;
    font-size:  larger;
}

.post {
    margin-bottom: 0.75em;
    padding-bottom:  0.25em;
-webkit-transition: all 0.5s ease;
-moz-transition: all 0.5s ease;
-ms-transition: all 0.5s ease;
-o-transition: all 0.5s ease;
transition: all 0.5s ease;
}

.post, .post .postReplies {
    background-color: #f4f5f4;
}


.postReplies .post {
    margin-top: 1em;
}

.postContent {
    white-space: pre-wrap;
}

.postContent button {
    margin-left: 1em;
    margin-top:  0.5em;
}

.selectedPost {
	border-left-color: #eca92e;
	border-left-width: 2em;
	border-left-style: solid;
	padding-left: 1em;
}

.reply a, div.subpost a.postReply {
	background-color: #fff88d;
	margin-bottom: 1em;
}

div.subpost a.postReply {
	text-align: right;
}

.odashbox {
	border: 3px dashed olive;
	margin: 1em;
	padding: 1em;
}

.dashbox {
	color: #000;
	background: #ddd;
	font-size: 80%;
	border: 1px dashed gray;
	padding: 1px;
	margin-top: 0px;
}

.actionbox {
    font-size: 80%;
}

a.forumlink {
	padding-left: 1em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat;
}

td.d-code.hasPosts {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat right bottom;
}

div.forumDiv div.subpost {
	background-color: #f5e3c2;
	margin-top:  0.25em;
	padding:  0.25em;
}

div.forumDiv div.subpost b {
	margin-right: 1em;
	display:  table-cell;
	padding-right:  1em;
}

div.forumDiv div.subpost .postHeader {
	display:  table-cell;
}

button.forumNewPostFlagButton {
    padding-left: 2em;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) no-repeat left center;
}

button.forumNewPostFlagButton:hover {
    padding-left: 2em;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat left center;
}

div.forumDiv .adminUserUser {
	background-color: lightgrey !important;
	margin: 3px !important;
	display:  block !important;
}
div.forumDiv span.adminUserName {
	font-size:  medium !important;
}
div.forumDiv .adminUserUser span.adminUserName,
div.forumDiv  .adminUserUser address,
div.forumDiv .adminUserUser i {
		float:none !important;
		margin:  0.25em !important;
}

div.forumDiv div.subpost div.postContent {
	padding-top:  0.5em;
	font: small Georgia, "Times New Roman", Times, serif;
	white-space: pre-wrap;
}

div.postReplies {
	margin-left: 0.5em;
	padding-left: 0.5em;
	padding-top:  0.25em;
	margin-top:  0.25em;
}

.forumLink {
    text-decoration: underline;
}

.forumLink:hover {
    color: blue;
    background-color: white;
    cursor:  pointer;
}

div.postReplies,
div.postReplies:hover > div.post > div.postReplies {
	border-left: 3px solid gray;
}

div.postReplies .post {
    margin-top: 0.25em;
}

div.postReplies:hover > div.post > div.postReplies:hover,
div.postReplies:hover
 {
    border-left:  3px solid red;
}


a.postItem {
	margin-left: 0.25em;
}

.disabledbox {
	font-size: 80%;
	color: #555;
}

.deactivated {
	color: #555;
}

td.framecell {
	border: ridge #ffb000 4px;
	background: #f6ffe8;
	color: black;
}

/* @group vetting */

.approved {
	border-color: green;
	border-style: ridge;
	margin: 1px;
	padding: 1px;
}

/* but, an insufficient table.. */

td.insufficient {
	border: none;
}

td.insufficient span.loser {
	border: 2px;
	border-color: #f0961b;
	border-style: dashed;
	margin: 1px;
	padding: 1px;
}


.extraAttribute_heading {

}
.extraAttributes .extraAttribute {
	display: inline;
	margin: 1em;
}
td.d-code .extraAttribute  {
	display: block;
}
.extraAttribute {
	font-family: Georgia, "Times New Roman", Times, serif !important;
	border: 1px solid purple;
	background-color: #ddf;
}

/* @end */

/* @group tzbox */

table.tzbox {
	border-collapse: collapse;
}

table.tzbox th {
	border-right: 1px solid gray;
	border-left: 1px solid gray;
	border-bottom: 2px solid gray;
	color: black;
}

table.tzbox td {
	padding-right: 0.2em;
	padding-left: 0.2em;
	border-right: 1px solid gray;
	border-left: 1px solid gray;
}

table.tzbox tr.r0 td {
	color: #555;
}

table.tzbox tr.r1 td {
	color: #555;
	background-color: #fe9;
}

table.tzbox tr.r0currentZone td {
	color: black;
	background-color: white;
}

table.tzbox tr.r1currentZone td {
	color: black;
	background-color: #fe9;
}

table.tzbox tt.codebox {
	background-color: white;
}

/* @end */

/* @group sqlbox */

table.sqlbox {
	border: 1px solid gray;
	border-collapse: collapse;
}

table.sqlbox th {
	border-right: 1px solid gray;
	border-left: 1px solid gray;
	border-bottom: 2px solid gray;
	color: navy;
	font-size: 50%;
	background-color: #dde;
}

table.sqlbox td {
	padding-right: 0.2em;
	padding-left: 0.2em;
	border-right: 1px solid gray;
	border-left: 1px solid gray;
}

table.sqlbox tr.r0 td {
	color: black;
}

table.sqlbox tr.r1 td {
	color: black;
	background-color: #fe9;
}

/* forms here don't need a margin */

table.sqlbox input {
	margin: 0;
}

table.sqlbox form {
	margin: 0;
}

/* @end */

.manageSubpages {
	padding-left: 2em;
	display: block;
	width: 50em;
}

.manageSubpages a,
.manageSubpages b {
    display:  block;
    border-radius: 5px;
    border:  1px solid gray;
    padding: 0.25em;
    color:  blue;
}

.manageSubpages a:hover,
.manageSubpages b:hover {
    background: silver;
    color: red;
}

#st-run-gui > .ferrbox {
	width: 90%;
	padding-left: 3em;
	padding-bottom: 1em;
	font-size: x-large;
}

.ferrbox {
	background-color: #ddd;
	border: 1px solid red;
	margin: .4em;
	padding: .2em;
}

div#toparea {
	border-bottom: 3px solid #e9f6e9;
	background-color: whitesmoke;
	font: normal 1.2em Georgia, "Times New Roman", Times, serif;
padding: 0;
}

.stNormalPage #toparea {
margin-top:  1em;
}

div#toparea img#stlogo {
	float: right;
	margin-left: auto;
	height: 2.5em;
	margin-right: 5.5em;
	padding-top:  8px;
	display: none;
}

.normal-title {
	font-weight:  bold;
}

.dcbox {
	margin-left:  0.3em;
	background-color: #ddd;
	padding:  0.1em;
}

.dcbox .dchelp {
	padding-left:  0.25em;
	font-style: italic;
}

.sterrmsg {
	background-color: #ddd;
	border: 1px solid red;
	margin: 1em;
	padding: 1em;
}

.deletebox {
	font-size: small;
	margin-left: 1px;
	margin-right: 1px;
	color: #d00;
	font-weight: bold;
	white-space: nowrap;
}

.unvotebox {
	font-size: small;
	margin-left: 1px;
	margin-right: 1px;
	margin-bottom: 2px;
	color: #00989e;
	font-weight: bold;
	white-space: nowrap;
}

.fnotebox {
	border: 1px solid #94a694;
	margin: 0.5em;
	padding: 0.2em;
	padding-left: 2em;
	background: #f5f5f5 url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat 0.25em center;
}

.okayText {
    padding-left: 2em;
    background: #DDFFDD url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 0.25em center;
}
.squoText {
    padding-left: 2em;
    background: #DDFFDD url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat 0.25em center;
}
.stopText {
    padding-left: 2em;
    background: #FFDDDD url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0.25em center;
}
.warnText {
    padding-left: 2em;
    background: #e4dcd4 url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat 0.25em center;
    padding-top: 2px;
    padding-bottom:  1px;
    margin-bottom:  3px;
}

.nobg {
	background-color: inherit !important;
}

a.dcLocale {
	color:  #555;
	text-decoration: none;
}

.specialHeader {
	border: 2px solid gray;
	margin: 0.5em;
	padding: 0.5em;
	font: small "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
}

.scorebox {
	font-size: small;
	font-style: italic;
}

.scorebox:before {
	content: '(';
}

.scorebox:after {
	content: ')';
}

/* @group voteinfo old - obsolete? */

table#voteinfo td {
	border-right: none !important;
	border-left: none !important;
}

table#voteinfo th {
	background-color: #ddd;
}

table#voteinfo tbody th:first-child {
	text-transform: capitalize;
}

table#voteinfo tbody th:first-child,
table#voteinfo thead th:first-child {
	background-color: #bbf;
	border-right: 2px solid black;
	font-weight: inherit;
}

table#voteinfo thead th:first-child {
	font-weight: bold;
}

/* @end */

/* @group voteInfo_perValue */

/* This is a global style used in several places in the ST
	Notably cldrSurvey.setLang() and also the <cldr-value> Vue control
*/
.cldrValue {
	white-space: pre-wrap;
	/* See the the section below this one for language specific CSS, including specific
		font overrides. */
	font-family: "Noto Sans",
					"Noto Sans Symbols",
					sans-serif;
}

/* lang specific CSS */

/*
NOTE: See http://www.w3.org/International/questions/qa-css-lang

The the following can work here:
:lang(de) {
  font-family: UnifrakturCook;
}

*/

/* Kashmiri and Urdu are typically in Nastaliq. Kashmiri in particular uses a letter that is
   not rendered correctly in Noto Naskh (see CLDR-16595) */

:lang(ks), :lang(ur) {
	font-family: "Noto Nastaliq Urdu";
}

/* The following is directly includeable as per https://github.com/saturngod/mmwebfonts/issues/4 */
@font-face {
font-family:'MON3 Anonta 1';
src:local('MON3 Anonta 1'),url('//mmwebfonts.comquas.com/fonts/mon3.ttf');
}

/*
Use padauk or MM3 if available, otherwise Mon3.
*/
:lang(my) {
  font-family:padauk,Myanmar3,'MON3 Anonta 1';
}

:lang(hnj) {
	font-family: "NotoSerifNyiakengPuachueHmong-Regular", "Noto Serif NP Hmong"
}

:lang(suz-Sunu) {
  font-family: "Noto Sans Sunuwar", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.voteInfo_perValue {
	display:  inline-table;
	vertical-align: top;
}

div.voteInfo_noVotes.voteInfo_td {
	white-space: nowrap;
	font-style: italic;
}

.voteInfo_winningItem {
	margin: 0 !important;
	padding:  0 !important;
	border:  none !important;
	text-align: left;
	display: inline-block;
}

.voteInfo_tr_heading {
	font-weight:bold;
}

.voteInfo_valueTitle {
	font-weight:bold;
}
.voteInfo_iconValue  {
	background-position: left top !important;
	padding-left:  20px !important;
	width:  inherit !important;
	height:  inherit !important;
}

div.voteInfo_orgColumn {
	font-weight: bold;
}

.voteInfo_orgHeading  div.voteInfo_orgColumn{
	border-top:  1px solid gray;
}

.voteInfo_td, div.voteInfo_iconBar  {
	padding-left:  0.10em;
	padding-right:  0.10em;
    border-top:  1px solid gray;
	padding-bottom: 2px;
   	padding-top:2px;
}

.voteInfo_tr_heading td {
	border-top: none;
}

div.voteInfo_iconBar {
	border:  none !important;
	display:inline-block;
	height:20px;
	position:relative;
	top:2px;
}


.voteInfo_voterInfo, .voteInfo_voteCount {
	border-top:  1px solid gray;
	overflow: visible;
	padding-left:4px;
}

.voteInfo_voterInfo {
	width:100%;
}

.voteInfo_orgsVote {
	font-weight: bold;
	padding-right:3px;
}

.voteInfo_voteTitle {
	font-size: 110%;
	font-weight: bold;
}
.voteInfo_orgsNonVote {
	color: #333;
	font-style: italic;
	padding-left:10px;
}

/* @end */

td.generatedexample {
	border-left: 1px solid silver;
	border-right: 2px solid gray;
}

table.innerPropItems td.generatedexample,
table.innerPropItems td.propcolumn {
	border-left: none;
	border-right: none;
	white-space: nowrap;
}

th.rowinfo {
	font-size: small;
	border-right: 1px solid gray;
	background-color: #eee;
}

a.refuri {
	color: #000;
	font-size: smaller;
}

ul.orgvotes {
	margin: 0px;
}

ul.orgvotes li {
	margin: 0px;
	font-size: small;
	list-style-type: circle;
	list-style-position: outside;
}

span.marks {
	font-size: smaller;
	background-color: #fff4c9;
}

span.marks b {
	font-size: x-small;
	background-color: #30f;
	color: #ffe4ca;
	margin: 1px;
	padding: 1px;
	border: 1px solid green;
}

div.topnotices a {
	color: black;
}

div.topnotices p {
	text-align: center;
	margin: 0;
	padding: 4px;
}

div.topnotices p.admin {
	background-color: red;
}

div#stchanged {
	display: none;
	background-color: yellow;
	padding: 3px;
	position: fixed;
	margin-left: 100px;
	top: 0;
	width: 50%;
	opacity: .9;
	border: 2px solid gray;
}

div.loading {
	background-color: whitesmoke;
	padding: 3px;
	position: fixed;
	margin-left: 100px;
	top: 0;
	width: 50%;
	opacity: 1;
	background-color: #FFEECC;
	border: 5px outset gray;
}

.hidden {
	display: none;
}

p.errCodeMsg {
    font-family: Georgia, "Times New Roman", Times, serif;
    font-weight: normal;
    font-style: normal;
    margin-left:  3em;
    margin-right:  3em;
    border:  2px solid silver;
	font-size: larger;
	white-space: pre-line;
	padding: 0.5em;
	background-color: #ecd290;
}

p.errCodeMsg .fgred {
	color: red;
}

#LoadingMessageSection p.errCodeMsg button {
    display:  inline-block;
    margin-top: 1em;
    font-size: larger;
	margin-left: 0.5em;
}

.cldr_substituted {
	background-color: #ddd;
    font-weight: normal;
    font-style: normal;
}

.cldr_background_auto {
	background-color: #EAEAF2;
    font-weight: normal;
    font-style: normal;
}


.cldr_example {
    border: 1px solid #66666E;
	margin-top:-1px;
	padding:1px;
}

/* set the direction using html dir, not CSS direction */
.cldr_example_auto {
    border: 1px solid #66666E;
	margin-top:-1px;
	padding:1px;
	text-align: center;
	background-color: #EAEAF2;
}

/* set the direction using html dir, not CSS direction */
.cldr_example_rtl {
    border: 1px solid #66666E;
	margin-top:-1px;
	padding:1px;
	text-align: center;
}

div.d-example {
    font: small "Lucida Grande", Lucida, Verdana, sans-serif;
    margin-top:7px;
}

/* bootstrap popover likes to force the alignment left, but we want it to follow the language */
.popover .d-example-popover {
	text-align: initial !important;
}

#stchanged_loc {
	font-weight: bold;
}

.unofficial {
	background-color: goldenrod;
}

div.topnotices div.unofficial {
	padding: 3px;
	position: fixed;
	top: 30px;
	right: 0;
	opacity: 0.9;
	text-align: center;
	display: none;
}

body > div.topnotices #betanotice {}

body > div.topnotices div.beta {
clear: right;
position: fixed;
left: 0;
top: 0;
z-index: 0;
}
div.beta {
	/*
-webkit-transform: rotate(-90deg);
	-webkit-transform-origin: right bottom;
	-moz-transform: rotate(-90deg);
	-moz-transform-origin: right bottom;
	-o-transform: rotate(-90 deg);
-o-transform-origin: right bottom;
-khtml-transform: rotate (-90deg);
-khtml-transform-origin: right bottom;
*/
/* filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); */
    opacity: 0.9;
	float: right;
	font-size: smaller;
	margin-top:  2px;
	margin-left:  2px;
background-color: yellow;
padding:  2px;
padding-top:  3px;
box-shadow: 1px 1px 1px gray;
line-height:  12px;
position:fixed;
top:120px;
right: 0%;
}

body.claro div.beta {
    position: fixed;
    right: 0;
    top: 0;
}

#betanotice img {
    height:  50%;
}

div.debugJsp {
	position: fixed;
	bottom: 0;
	right: 0;
	border: 1px solid gray;
	margin: 0.5em;
}

span.elapsedtime {
	font-size: smaller;
}

span#visitors table {
	position: absolute;
	right: 0;
}

span#visitors table.stprogress {
	border: 1px solid #ccc !important;
}

span#visitors td.bar {
	background: #ddd !important;
	border: none !important;
}

span#visitors td.remain {
	background: #2e2 !important;
	border: none !important;
}

table.progress-list {
	border-collapse: collapse;
	position: fixed;
	top: 0;
	left: 0;
}

table.progress-busy {
	border-bottom: 3px solid red;
	border-right: 3px solid red;
}

table.progress-idle {
	border-bottom: 2px dashed green;
	border-right: 2px dashed green;
	opacity: 0.8;
}

table.progress-list tr th {
	vertical-align: top;
	background-color: #eee;
	opacity: .8;
	padding-left: 1em;
	color: red;
}

table.progress-list tbody tr td {
	background-color: #bbb;
	opacity: .9;
	border-left: 3px dashed gray;
	padding-left: 1em;
}

table.progress-list #busy0 {
	display: block;
}

/* Overrides */

span#progress.popout table.progress-list td {
	display: table-cell !important;
}

span#progress.popout table.progress-list #busy0 {
	display: none !important;
}

span#progress.popout table.progress-list #busy1 {
	display: block !important;
}

table.progress-list tbody tr td:first-child {
	opacity: 1.0;
	background-color: whitesmoke;
	border-left: none;
	padding-left: 0;
}

table.stprogress {
	margin: 5px;
	padding: 0;
	border-collapse: collapse;
	border: 2px solid black;
}

div.vvprogress {
	display: run-in;
}

div.vvprogress  div {
	height: 16px;
	display: table-cell;
}

table.stprogress td.bar, div.vvprogress div.bar{
	padding: 0;
	margin: 0;
	border-left: 2px solid black;
	border-right: 1px solid silver;
	background: #6c31fe url(${___CSS_LOADER_URL_REPLACEMENT_12___}) repeat scroll left;
}

table.stprogress td.remain, div.vvprogress div.remain {
	padding: 0;
	margin: 0;
	border-left: none;
	border-right: 2px solid black;
	background: #ddd url(${___CSS_LOADER_URL_REPLACEMENT_13___}) repeat;
}

label.menutop-active {
	border: 2px solid green;
	background-color: navy;
	color: white;
}

select.menutop-active {
	margin: 0;
}

/* visible menu, please.  */
select.menutop-other,
select.menutop-active
 {
	background-color: white;
	color: black !important;
	font-weight: normal !important;
}

#sectionmenu {
	padding-top:  0.5em;
}

label.menutop-active, label.menutop-other,
#sectionmenu label {
	padding-left: 0.5em;
	padding-right: 0;
	white-space: nowrap;
}

/* classes for ajax form responses */

.user_email {
 font-size: small;
	font-style: italic;
}

.user_name {
	color: navy;
}

.user_org {
	color:  navy;
}

/*
 * tr_checking1, tr_checking2:
 * A row temporarily changes its background color to indicate that the user has
 * initiated an action, such as voting for an item.
 * The color changes per tr_checking1 as soon as the user clicks.
 * The color changes per tr_checking2 when a response is received from the server.
 * The color changes back to normal after the response has been processed.
 * The classes tr_checking1, tr_checking2 are used not only to change the appearance,
 * but also to prevent the row from being updated when a multiple-row response is received;
 * see insertRowsIntoTbody.
 */
tr.tr_checking1 {
	background-color: orange;
	opacity: 0.5;
}

tr.tr_checking2 {
	background-color: #d4edd9; /* green */
	opacity: 0.75;
}

tr.tr_warn {
	background-color: yellow;
}

tr.tr_err {
	background-color: red;
}

/*
 * tr_submit highlights a row when a dialog is open for submitting a new value.
 * Usually the position of the dialog is a good indicator of the row to which it corresponds. However,
 * if the row is near the top or bottom of the window, the dialog may be positioned higher or lower in
 * order to be completely visible. The distinctive style of the row may then help to avoid confusion.
 */
tr.tr_submit {
	background-color: #dfd; /* pale green */
}

div.v-oldVotes-subDiv {
    margin-left:  1em;
}

h2.v-oldvotes-sub {
    border-top:  2px solid silver;
}

div.helpHtml, .helpContent {
    background: #eed;
    font: medium Georgia, "Times New Roman", Times, serif;
}

div.helpHtml table {
    border: 1px solid black;
    border-collapse: collapse;
}

div.helpHtml td,div.helpHtml td th {
    border: 1px solid black;
    padding: 3px;
}

.graybox {
	border: 1px solid gray;
	margin: 3px;
	font-size: small;
}

/* @group AJAX build */

.d-sortmode {
	border: 1px solid gray;
	background-color: #e3fbff;
	padding: 0.2em 0.2em 0.2em 0.2em;
	margin-top: 2px;
	font-size: smaller;
	display:  table;
	display:  none;
}

#oldVotesAcceptList tr.subheading th{
    text-align: left;
    background-color: rgba(85, 193, 193, 0.58);
}

span.pathChunk {
    margin-right:  1em;
    font: italic normal small Georgia, "Times New Roman", Times, serif;
}

#oldVotesAcceptList tbody tr td.v-path {
    font-family: "Courier New", Courier, mono;
    font-weight: bold;
}

span.pathChunk:after
{
    content: ':';
}

.d-sortmode .d-sort-size0 {
	font-size: x-large;
	padding-left:  1em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat left center;
	background-color: white;
}

.d-sortmode ul {
	display: none; /* inline*/
	margin-top: 0;
	margin-bottom: 0;
 	margin-left: 0;
 	padding-left:  0;
}

.d-sortmode li {
	display: inline;
	margin-left: 10px;
}

.d-sortmode li.notselected {
	text-decoration: underline;
	color: blue;
}

.d-st-warn {
	width: 16px;
	height: 16px;
	background: yellow url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center center;
}

.d-st-stop {
	width: 16px;
	height: 16px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}

.d-st-okay {
	width: 16px;
	height: 16px;
}

.d-dr-approved {
	color: green;
}

.d-dr-contributed,.d-dr-provisional,.d-dr-inherited-provisional {
	color: orange;
}

.d-dr-unconfirmed,.d-dr-inherited-unconfirmed {
	color: red;
}

.d-dr-missing {
	color: black;
}

.statuscell {
	text-align: right;
	font-family: emoji !important;
	font-variant-emoji: emoji;
}

.voteDiv .winningStatus  {
	padding-left: 20px;
	background-position: left !important;
	width: inherit !important;
}


.voteDiv .lastReleaseStatus1 {
    background: none !important;
}

.voteDiv .lastReleaseStatus0 {
	background: none !important;
 margin-left: 2em;
}

.voteInfo_key {
	padding-left:  1em;
}

h3.voteInfo_key_title {
	margin-bottom: .1em;
}

.d-code {
    vertical-align: top;
	font: bold small "Courier New", Courier, mono;
}

.d-disp {
	vertical-align: top;
	padding-left:  2px;
	padding-right:  2px;
}

.d-no-vo-false {
    text-align: center;
    background: #9999d0;
}

.d-no-vo-true {
    text-align: center;
}

.d-no, .d-status {
    width:  32px;
}

.d-item {
	display:  inline-box;
	clear:both;
}

.d-item span span {
     display:  inline !important;
}

#pu-content div.helpHtml {
	margin-bottom:  0.5em;
}

tr.d-inforow, .d-item-selected {
	background-color: #eff;
}

tr.d-inforow td {
	padding: 0.5em;
	border-bottom: 3px solid gray;
	border-left:  none;
	border-right:  none;
}
tr.d-inforow td h3.span {
	font-size: large;
}

.pu-select {
	border: 2px double black !important;
}

.d-item-selected {
	border: 2px solid navy;
}

tr.d-inforow-hid {
	display: none;
}

.menu-o {
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
    width: 16px;
    height: 16px;
    margin-top: 5px;
}

.menu-zoom {
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center;
    width: 16px;
    height: 16px;
    margin-top: 5px;
}

.menu-chat {
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat center center;
    width: 16px;
    height: 16px;
    margin-top: 5px;
}

.menu-x {
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
    width: 16px;
    height: 16px;
    margin-top: 5px;
}

.dijitMenuExpand {
	margin-top: 5px !important;
}

button.ichoice-o {
	width: 2em;
	height: 2em;
	background: white url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
	margin: 1px;
}

button.ichoice-o:hover {
	width: 2em;
	height: 2em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
	background-color: gray;
	margin: 1px;
}

button.ichoice-o-okay {
	width: 2em;
	height: 2em;
	background: lime url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
	margin: 1px;
	border: 2px solid green;
}

button.ichoice-o-okay:hover {
	width: 2em;
	height: 2em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat center center;
	background-color: gray;
	margin: 1px;
}

button.ichoice-x {
	width: 2em;
	height: 2em;
	background: white url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
	margin: 1px;
}

button.ichoice-x:hover {
	width: 2em;
	height: 2em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
	background-color: gray;
	margin: 1px;
}
button.ichoice-x-ok {
	width: 2em;
	height: 2em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
	margin: 1px;
	opacity: 0.5;
	border:  2px solid green;
}

button.ichoice-x-ok:hover {
	width: 2em;
	height: 2em;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center center;
	background-color: gray;
	margin: 1px;
}

span.i-override {
	font-size: 	x-small;
	margin-left: 0.25em;
}
span.i-override, .voteInfo_overrideExplain {
	font: "Helvetica Neue", Arial, Helvetica, Geneva, sans-serif;
	background-color: lime;
	color: navy;
	border:  1px solid navy;
	padding:  1px;
}
span.i-override::before {
	content:  "(";
}
span.i-override::after {
	content:  "!)";
}

body.disconnected table.data button,
body.disconnected table.data input,
body.disconnected table.data .d-change,
body.disconnected table.data .d-change-err,
body.disconnected table.data .d-change-warn,
body.disconnected table.data .d-no,
body.disconnected table.data .d-no-vo-false,
body.disconnected table.data .d-no-vo-true {
	display: none !important;
}

button#progress-refresh {
    display: none;
    bottom: 0.25em;
    position: absolute;
    right: 0.25em;
    font-size: x-small;
}
button#progress-details {
	display: block;
    font-size: x-small;
}

textarea.errorMessage {
	display: block;
	width: 100%;
	height: 10em;
}

div.possibleProblems {
	border: 1px dashed olive;
	padding: 0.2em;
	background-color: #FFFDD0;
	overflow: auto;
}

div.possibleProblems h3 {
	margin:  0;
}

div.possibleProblems div {
	display: block;
}

div.possibleProblems div p {
	margin-top: .2em;
	margin-bottom: .2em;
	padding-left:  0.5em;
	font-size:  larger;
	list-style-type: square;
	display:  list-item;
	list-style-position: inside;
}

div.possibleProblems div p img {
	padding-right:  0.25em;
}

body.disconnected div#progress button#progress-refresh {
	display: block !important;
}

body.disconnected div#progress.progress-ok  button#progress-refresh {
	display: none !important;
}

div#progress.progress-special,
div#progress.progress-special span.oneword{
	font-weight: bold;
	text-decoration: none;
}

div#progress, div#progress span {
transition: background-color 0.2s;
-moz-transition: background-color 0.2s;
-webkit-transition: background-color 0.2s;
-o-transition: background-color 0.2s;
}

.i-star {
	padding: 2px;
	width: 16px;
	height: 16px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center center;
}

.i-star,.label-icon {
	position:relative;
	left:5px;
	display:inline-block;
	vertical-align: middle;
}

.i-stop {
	padding: 2px;
	width: 17px;
	height: 17px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.i-warn {
	padding: 2px;
	width: 17px;
	height: 17px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat center center;
}
.i-flag {
	padding: 2px;
	width: 17px;
	height: 17px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center;
}

.s-flag {
	width: 17px;
	height: 30px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) no-repeat center center ;
}

td.d-change,td.d-change-err,td.d-change-warn {
	white-space: nowrap;
}

button.d-inforow-hider {
	float: right;
}

.inputbox {
	width: 75%;
}

.d-item,.d-item-warn,.d-item-err,
td.d-change,td.d-change-err,td.d-change-warn {
	vertical-align: top;
	margin-top:-3px;
}

td.d-change-err, td.d-win-err, .d-item-err {
	background: #fa9092 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right top !important;
}

.d-item-err-noicon {
	background: #fa9092;
}

td.d-change-confirmonly {
	background: #d9edf7;
}

td.d-change-confirmonly .fnotebox {
	display: block;
	border: 0 !important;
	margin-top: 0.5em;
}

td.d-change-warn, td.d-win-warn, .d-item-warn {
	background: #fcf8e3 !important;
}

td.d-win {
}

/* @end */

/* @group Popup */

div#pu-peak {
	width: 11px;
	height:  16px;
	/*border:  1px solid green;*/
	background: #f8c871 none;
	position: absolute;
	left: 100px;
	top: 10em;
	opacity:  0.9;
	color: black;
	vertical-align: top;
	text-align: right;
	z-index: 6;
}

div#pu-content {
	display: none;
	height: 180px;
	padding: 0.2em;
	padding-bottom: 0;
	box-shadow: 3px 3px 5px gray;
	border:  2px solid #f8c871;
	padding:  .5em;
	background-color: white;
	font-size:  small;
	overflow: scroll;
	z-index: 6;
	position: fixed;
	bottom: 12px;
	left: 2em;
	right:  2em;
}

#pu-content h3.span {
	margin-top:  0;
	margin-bottom: 0;
}

/* @end */

.anch,.anch-go {
	padding: 5px;
	font: small Georgia, "Times New Roman", Times, serif;
}

.recentList {
	display: table;
}

.recentList div {
	display: table-row;
}

.recentList div a,
.recentList div b,
.recentList div span {
	display: table-cell;
	padding: 2px;
	border-bottom: 1px solid gray;
}

.recentList div b {
	background-color: #ddd;
}

div.voterList {
	display:  block;
}

div.voterList .voterName {
	font-weight: bold;
	display:  inline;
}

div.voterList p {
	display:  table-row;
	margin-left:  0.25em;
	padding-left:  20px;
	padding-top: 0;
	margin-top:0;
	margin-bottom:  0.5em;
}

.rolloverspan:hover {
	color: white !important;
	background-color: navy !important;
	transition: background-color 0.5s ease;
}

button.forumShow {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) no-repeat left center;
    padding-left: 20px;
}

body.claro > table#usertable,
body.claro > div#toparea,
body.claro > div#sectionmenu,
body.claro > div#footer {
	display:  none;
}

#st-menubar  {
    width: 40em;
    display:  inline-block;
}

#borderContainer {
	top:  0;
    height: 100%;
}

span.editableHere {
    padding:  2px;
}

#oldVotesAcceptList th {
    background-color: #ddd;
}

#oldVotesAcceptList tbody tr:hover {
    background-color: #d7ca90;
}
th.v-accept a {
    padding: .5em;
    font-size: small;
}

td.v-path {
    white-space: nowrap;
    font: small Georgia, "Times New Roman", Times, serif;
    border:  1px solid black;
    background-color:  white;
}

#revision-info {
	font-size: x-small;
	whitespace: nowrap;
}

#oldVotesAcceptList {
    border-collapse: collapse;
}

#oldVotesAcceptList td {
    padding:  0.4em;
    border-bottom:  1px solid gray;
    vertical-align: bottom;
}

#title-item {
    font-family: "Courier New", Courier, mono;
    font-size: small;
}

.menu-container {
    display:  inline;
}

.menu-container::before{
    color:  black;
}

.menu-container:first-child:before {
	content: '';
}
/*
  TODO: make this dynamic.
  */
.hideCov101 .cov101,
.hideCov100 .cov100,
.hideCov80 .cov80,
.hideCov60 .cov60,
.hideCov40 .cov40,
.hideCov30 .cov30,
.hideCov10 .cov10 {
	display: none;
}

.hideCov101 .selectShow.cov101,
.hideCov100 .selectShow.cov100,
.hideCov80 .selectShow.cov80,
.hideCov60 .selectShow.cov60,
.hideCov40 .selectShow.cov40,
.hideCov30 .selectShow.cov30,
.hideCov10 .selectShow.cov10 {
    display: table-row !important;
    background-color: silver !important;
}

#LoadingMessageSection {
    text-align: center;
    padding-top:  3em;
}

#loginlink {
    color:  maroon;
    font-size: large;
    font-weight: bold;
}

#ariHelp  {
    float: right;
}

#ariMessage {
    padding-left:  20px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left top;
    font-family: "Lucida Grande", Lucida, Verdana, sans-serif;
    font-weight: bold;
}

.fakebutton {
    border-style: outset;
}

#ariSub {
    font: small "Lucida Grande", Lucida, Verdana, sans-serif;
    margin-bottom: 0;
}

#ariScroller {
    white-space: pre;
    overflow: scroll;
    font: small "Courier New", Courier, mono;
    padding-left:  32px;
    padding-top:  0;
}

.dijitDialogUnderlay, .claro .dijitDialogUnderlay {
    opacity: 0.5 !important;
    background-color: #b1b56a !important;
}

.mailListChunk, .mailContentChunk {
    width: 48%;
    display:  inline-block;
    vertical-align: top;
}

.mailListChunk .loser {
    border: 1px dashed red;
    background-color: #fdd;
}
.mailListChunk .warning {
    border: 1px solid yellow;
}

.mailContentChunk {
    border:  1px solid gray;
    padding:  0.5em;
}

h2.mailHeader {
    margin: 0;
    font: bold medium Georgia, "Times New Roman", Times, serif;
}

p.mailContent {
    line-height: 1em;
    white-space: pre-line;
}

.mailListChunk li:hover {
    background-color: gold;
}

.mailListChunk li.mailRow {
    font-weight: bold;
    list-style-type: decimal;
}

.mailListChunk li.mailRow.readMail {
    font-weight: normal;
}

.st_setup_text {
	padding: 0.5em;
	font-size: large;
}

ol.st_setup li {
	margin-bottom: 1em;
}

div.st_setup  {
	font-size: x-large;
	padding: 1em;
	background-color: #ddf;
}

.bulkNextButton, .bulkNextInfo {
	position: fixed;
	bottom: 1em;
	z-index: 50;
}

.bulkNextButton {
	right: 1em;
	margin: 0.5em;
	padding: 0.5em;
}

div.bulkNextButton {
	background-color: white;
	border: 1px solid black;
}

.bulkNextInfo {
	left: 1em;
	background-color: white;
	margin: 0.5em;
	padding: 0.25em;
	border: 2px solid gray;
}

.bulkNextInfo ul {
	display: table-row;
	margin: 0;
	padding:0 ;
}

.bulkNextInfo ul li {
	display: table-cell;
	text-align: center;
	margin: 0;
	padding: 0;
}

.bulkNextInfo ul li.active {
	color: black;
	background-color: lime;
}

.bulkNextInfo ul li.inactive {
	color: gray;
}
.bulkNextInfo ul li.inactive h2 {
	display: none;
}

.bulkNextInfo li h1,
.bulkNextInfo li h2 {
	padding:0.25em;
	margin:0.25em;
}
.bulkNextInfo li h1 {
	font-size: large;
}
.bulkNextInfo li h2 {
	font-size: smaller;
}

.bulkNextInfo ul li.active::before,
.bulkNextInfo ul li.inactive::before {
	content: '»';
}

div.bulkInputForm {
	margin: 1em;
	display: table;
}

div.bulkInputForm div {
	display: table-row;
}

div.bulkInputForm div input,
div.bulkInputForm div label {
	display: table-cell;
	margin-left: 1em;
}

.infos-code {
	float:right;
}

.vsNav {
	padding: .5em;
	border-top: 2px solid gray;
}

.vsNav button {
	padding: 2px;
	font-size: larger;
}

span.vsStatus {
	margin-left: 1em;
	background-color: white;
	display: block;
}

.vsContent.vsStale {
	color: gray;
	background-color: #dddddd;
	opacity: .5;
}

.manage-list-icon {
	padding-left: 0.25em;
}

table.flaggedItems .codebox,
table.flaggedItems .adminUserUser {
    display:  none;
}

table.flaggedItems .r1 {
    background-color: #f1fafa;
}

table.flaggedItems th, table.flaggedItems td {
    padding:  0.25em;
}

table.flaggedItems .flaggedPath {
    font-weight:  normal;
}

.flaggedItemsBox {
    margin:  1em;
}

.special_flagged {
	display:  table;
}

.special_flagged .flaggedLocaleHeader {
	display:  table-row;
	background-color:  #fee;
	padding-top:  4em;
}

.special_flagged h3 {
	padding-left: 32px;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) left center no-repeat;
}

.special_flagged div.flaggedItem {
	display:  table-row;
}
.special_flagged div span {
	padding-right:  .5em;
}

.special_flagged .flaggedLocaleHeader span {
	padding-left:  1em;
}

.special_flagged div span,
.special_flagged div .thinUser {
	display:  table-cell;
}

.special_flagged .dateChunk {
	padding-left:  1em;
}

.special_flagged .thinUser {
	margin-left:  20px;
}
.special_flagged div .thinUser img {
	float:  left;
}

.special_flagged .thinUser .adminUserName {
	font-size:  small;
}

div.thinUser {
	border:  1px solid gray;
	border-radius: .5em;
	padding: 0.1em;
}

.special_flagged .pathHeaderInfo {
	font-size:  smaller;
	white-space: nowrap;
}

.followAlias {
	display: block;
}

/* vetting participation */
#vettingParticipation .locList {
    display: block;
    list-style: none;
}

#vettingParticipation .locRow {
    display: block;
}

#vettingParticipation .locId {
    display: block;
    padding-right: 1em;
    border: 1px solid gray;
    border-top: 2px solid black;
    font-size: larger;
    margin-top: 1em;
    padding-top: .25em;
    background-color: lightgray;
}

#vettingParticipation .count {
	padding-left: 1em;
    font-size: smaller;
    font-family: monospace;
}

#vettingParticipation .locId .count {
	float: right;
}

#vettingParticipation .missingLoc {
    background-color: #f88;
    margin-left: 5em;
}

#vettingParticipation .participatingUser {
    border: 1px solid gray;
     border-radius: .5em;
     padding: .3em;
     display: inline-flex;
     width: 25em;
}

#vettingParticipation .participatingUser .userInfo {
     width: 20em;
	white-space: nowrap;
}

#vettingParticipation .participatingUsers {
     display: block;
    padding-top: 1em;
    margin: 2em;
 }

 #vettingParticipation .vetter {
     font-weight: bold;
     padding: .1em;
     background-color: rgb(181, 207, 199);
 }

 #vettingParticipation .noparticip {
     color: red;
     background-color: lightgoldenrodyellow !important;
 }

.sidebyside-narrow a[href] {
	word-wrap: break-word;
}

footer {
	margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./../src/main/webapp/surveytool.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE,oCAAoC;AACpC,gBAAgB;;AAEhB,uGAAuG;;AAOvG;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;CAC7B,2BAA2B;CAC3B,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;CACtB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,6EAA6E;CAC7E,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;CACC,uBAAuB;CACvB,4BAA4B;CAC5B,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,+BAA+B;AAChC;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,mEAAmE;IACnE,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;AACb;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,wBAAwB;CACxB,aAAa;CACb,YAAY;CACZ,uBAAuB;CACvB,cAAc;CACd,aAAa;AACd;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;CACC,UAAU;CACV,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;IACX,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,UAAU;CACb,4DAA4D;CAC5D,gBAAgB;CAChB,4BAA4B;AAC7B;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,+BAA+B;AACnC;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,yCAAyC;CACzC,iBAAiB;AAClB;;AAEA;CACC,mDAAmD;CACnD,iBAAiB;CACjB,gBAAgB;CAChB,wBAAwB;CACxB,yBAAyB;CACzB,4BAA4B;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;AACA;IACI,wBAAwB;AAC5B;;AAEA;CACC,iCAAiC;CACjC,wBAAwB;AACzB;AACA;CACC,kCAAkC;CAClC,wBAAwB;AACzB;AACA;CACC,iCAAiC;CACjC,yBAAyB;AAC1B;AACA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;AACA;CACC,mCAAmC;CACnC,yBAAyB;AAC1B;AACA;CACC,mCAAmC;CACnC,wBAAwB;AACzB;;;AAGA,2BAA2B;;;AAG3B;CACC,YAAY;CACZ,wBAAwB;CACxB,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,oDAAoD;CACpD,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;AACb;;;AAGA;CACC,yBAAyB;CACzB,YAAY;CACZ,YAAY;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;CACC,iBAAiB;CACjB,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,eAAe;IACZ,kBAAkB;AACtB;;AAEA;CACC,iDAAiD;IAC9C,mBAAmB;AACvB;;;;AAIA;CACC,aAAa;AACd;;AAEA;;;AAGA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;CACC,gBAAgB;AACjB;;AAEA,wBAAwB;;AAExB,gCAAgC;;AAEhC;CACC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,SAAS;;AAET;CACC,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;CACjB;AACD;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;CAC5B,uBAAuB;CACvB,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;CACxB,uBAAuB;;AAExB;AACA;CACC,kCAAkC;CAClC,0BAA0B;AAC3B;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC;AACD;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,cAAc;CACd,WAAW;CACX,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,qDAAqD;CACrD,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,mEAAmE;AACpE;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,aAAa;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,mEAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,mEAA0C;AAC9C;;AAEA;CACC,mBAAmB;CACnB,mEAAyC;CACzC,oDAAoD;AACrD;;AAEA;CACC,mBAAmB;CACnB,0BAA0B;CAC1B,iBAAiB;CACjB,qDAAqD;CACrD,mEAAyC;CACzC,oBAAoB;CACpB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,sBAAsB;CACtB,oCAAoC;AACrC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,mEAAyC;AAC1C;;AAEA;CACC,mBAAmB;CACnB,wDAAwD;CACxD,YAAY;CACZ;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,mEAAyC;CACzC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,+BAA+B;CAC/B,mBAAmB;CACnB,oBAAoB;AACrB;;;AAGA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;;;CAIC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;CACV,oBAAoB;CACpB,wCAAwC;CACxC,yBAAyB;CACzB,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,cAAc;AACf;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mEAAmE;AACpE;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB;EACC;CACD,WAAW;CACX,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,yDAAyD;CACzD,WAAW;AACZ;;AAEA;CACC,yDAAyD;CACzD,WAAW;AACZ;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;EACC;IACE,WAAW;CACd,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,gCAAgC;;;AAGjC,8BAA8B;CAC7B,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;AAC3B;;AAEA;;AAEA;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,WAAW;AACZ,eAAe;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;IACb,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;CACC,iBAAiB,EAAE,WAAW;CAC9B,mCAAmC;AACpC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB,GAAG,MAAM;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;;;AAGlB;;mBAEmB;AACnB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;CACC,UAAU;CACV,aAAa;AACd,wBAAwB;CACvB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;CACC,0BAA0B;CAC1B,WAAW;CACX,eAAe;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;CACC,uBAAuB;CACvB,UAAU;CACV,WAAW;CACX,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;IACI,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;;AAGA;IACI,6DAAmC;IACnC,0BAA0B;AAC9B;;AAEA;;IAEI,kEAAwC;IACxC,0BAA0B;AAC9B;AACA;;IAEI,mEAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;;AAEA;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;CACC,yBAAyB;CACzB,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;CACb,oBAAoB;CACpB,kBAAkB;CAClB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,mBAAmB;CACnB,mBAAmB;CACnB,iBAAiB;CACjB,+BAA+B;CAC/B,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;AACvB;;AAEA;;;;;;;CAOC;;;AAGD;CACC,yDAAmC;CACnC,4BAA4B;CAC5B,iBAAiB;CACjB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,0BAA0B;CAC1B,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;CACV,mBAAmB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sEAAsE;AAC1E;;AAEA;;AAEA;;AAEA;;;AAGA,cAAc;CACb,eAAe;AAChB;;sBAEsB;AACtB;;AAEA;CACC,cAAc;CACd,4CAA4C;AAC7C;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB;AACD;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC;AACD;;AAEA;CACC;AACD;;AAEA;CACC,yBAAyB;CACzB,cAAc;CACd,0BAA0B;CAC1B,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,qCAAqC;CACrC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,gBAAgB;CAChB,UAAU;IACP,0BAA0B;AAC9B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,sCAAsC;CACtC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B,iCAAiC;AACjC,8BAA8B;AAC9B,6BAA6B;AAC7B,4BAA4B;AAC5B,yBAAyB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,wBAAwB;CACxB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,YAAY;CACZ,eAAe;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;CACC,iBAAiB;CACjB,6DAAmC;AACpC;;AAEA;CACC,0EAAgD;AACjD;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;IACI,iBAAiB;IACjB,yEAAiD;AACrD;;AAEA;IACI,iBAAiB;IACjB,yEAA+C;AACnD;;AAEA;CACC,sCAAsC;CACtC,sBAAsB;CACtB,0BAA0B;AAC3B;AACA;CACC,6BAA6B;AAC9B;AACA;;;EAGE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;CACC,mBAAmB;CACnB,oDAAoD;CACpD,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,2BAA2B;AAC/B;;;AAGA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;;AAEA,mBAAmB;;AAEnB;CACC,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,YAAY;AACb;;AAEA,iCAAiC;;AAEjC;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,oBAAoB;CACpB,WAAW;CACX,YAAY;AACb;;;AAGA;;AAEA;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,gEAAgE;CAChE,wBAAwB;CACxB,sBAAsB;AACvB;;AAEA,SAAS;;AAET,iBAAiB;;AAEjB;CACC,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,6BAA6B;CAC7B,YAAY;AACb;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA,SAAS;;AAET,kBAAkB;;AAElB;CACC,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,6BAA6B;CAC7B,WAAW;CACX,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA,mCAAmC;;AAEnC;CACC,SAAS;AACV;;AAEA;CACC,SAAS;AACV;;AAEA,SAAS;;AAET;CACC,iBAAiB;CACjB,cAAc;CACd,WAAW;AACZ;;AAEA;;IAEI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;CACC,UAAU;CACV,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,2DAA2D;AAC5D,UAAU;AACV;;AAEA;AACA,gBAAgB;AAChB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;CACd,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,cAAc;CACd,iBAAiB;CACjB,oFAAyD;AAC1D;;AAEA;IACI,iBAAiB;IACjB,oFAAyD;AAC7D;AACA;IACI,iBAAiB;IACjB,mFAAyD;AAC7D;AACA;IACI,iBAAiB;IACjB,mFAAyD;AAC7D;AACA;IACI,iBAAiB;IACjB,oFAAyD;IACzD,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,cAAc;CACd,kEAAkE;AACnE;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA,oCAAoC;;AAEpC;CACC,6BAA6B;CAC7B,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;;CAEC,sBAAsB;CACtB,6BAA6B;CAC7B,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,SAAS;;AAET,6BAA6B;;AAE7B;;CAEC;AACD;CACC,qBAAqB;CACrB;mBACkB;CAClB;;eAEc;AACf;;AAEA,sBAAsB;;AAEtB;;;;;;;;CAQC;;AAED;0DAC0D;;AAE1D;CACC,iCAAiC;AAClC;;AAEA,kGAAkG;AAClG;AACA,2BAA2B;AAC3B,yEAAyE;AACzE;;AAEA;;CAEC;AACD;EACE,2CAA2C;AAC7C;;AAEA;CACC;AACD;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,wBAAwB;CACxB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,wCAAwC;CACxC,8BAA8B;CAC9B,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;IACnB,2BAA2B;CAC9B,mBAAmB;IAChB,eAAe;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;CACpB,WAAW;CACX,iBAAiB;CACjB,OAAO;AACR;;;AAGA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA,SAAS;;AAET;CACC,6BAA6B;CAC7B,4BAA4B;AAC7B;;AAEA;;CAEC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,wBAAwB;CACxB,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,4BAA4B;CAC5B,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,UAAU;CACV,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;IACI,qDAAqD;IACrD,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;CAC5B,iBAAiB;CACjB,qBAAqB;CACrB,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;CACpB,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;CACC,yBAAyB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,yBAAyB;CAC5B,eAAe;CACf,WAAW;AACZ;;AAEA,wDAAwD;AACxD;IACI,yBAAyB;CAC5B,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA,wDAAwD;AACxD;IACI,yBAAyB;CAC5B,eAAe;CACf,WAAW;CACX,kBAAkB;AACnB;;AAEA;IACI,wDAAwD;IACxD,cAAc;AAClB;;AAEA,+FAA+F;AAC/F;CACC,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,SAAS;CACT,QAAQ;CACR,YAAY;CACZ,kBAAkB;CAClB,aAAa;AACd;;AAEA,mCAAmC;;AAEnC;AACA,YAAY;AACZ,eAAe;AACf,OAAO;AACP,MAAM;AACN,UAAU;AACV;AACA;CACC;;;;;;;;;CASA;AACD,sEAAsE;IAClE,YAAY;CACf,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB,wBAAwB;AACxB,aAAa;AACb,iBAAiB;AACjB,4BAA4B;AAC5B,kBAAkB;AAClB,cAAc;AACd,SAAS;AACT,SAAS;AACT;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,eAAe;CACf,SAAS;CACT,QAAQ;CACR,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,MAAM;CACN,OAAO;AACR;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;CAC/B,8BAA8B;CAC9B,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;CACX,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,4BAA4B;CAC5B,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA,cAAc;;AAEd;CACC,8BAA8B;AAC/B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,yBAAyB;CACzB,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,SAAS;CACT,4BAA4B;CAC5B,8BAA8B;CAC9B,+EAAoD;AACrD;;AAEA;CACC,UAAU;CACV,SAAS;CACT,iBAAiB;CACjB,6BAA6B;CAC7B,gEAAqC;AACtC;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,SAAS;AACV;;AAEA,2BAA2B;AAC3B;;;CAGC,uBAAuB;CACvB,uBAAuB;CACvB,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA,oCAAoC;;AAEpC;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;;;;;;;;;;EAUE;AACF;CACC,wBAAwB;CACxB,YAAY;AACb;;AAEA;CACC,yBAAyB,EAAE,UAAU;CACrC,aAAa;AACd;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;;;;EAKE;AACF;CACC,sBAAsB,EAAE,eAAe;AACxC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,YAAY;AAChB;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,gBAAgB;AACjB;;AAEA,sBAAsB;;AAEtB;CACC,sBAAsB;CACtB,yBAAyB;CACzB,gCAAgC;CAChC,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,kEAAkE;AACtE;;AAEA;IACI,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA;;IAEI,YAAY;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,0EAA+C;CAC/C,uBAAuB;AACxB;;AAEA;CACC,aAAa,EAAE,UAAU;CACzB,aAAa;CACb,gBAAgB;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mFAAwD;AACzD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,2EAAiD;AAClD;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,oCAAoC;CACpC,yBAAyB;AAC1B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;IACI,mBAAmB;CACtB,6CAA6C;AAC9C;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,oBAAoB;CACpB,UAAU;AACX;;AAEA;KACK,2BAA2B;AAChC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,6BAA6B;CAC7B,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;IACI,kFAAuD;IACvD,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iFAAuD;IACvD,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iFAAuD;IACvD,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kFAAuD;IACvD,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,WAAW;CACX,kFAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,4EAAiD;CACjD,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,iFAAsD;CACtD,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,4EAAiD;CACjD,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,kFAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,4EAAiD;CACjD,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,UAAU;CACV,WAAW;CACX,4EAAiD;CACjD,WAAW;CACX,YAAY;CACZ,wBAAwB;AACzB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,4EAAiD;CACjD,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,4DAA4D;CAC5D,sBAAsB;CACtB,WAAW;CACX,uBAAuB;CACvB,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;;AAEA;;;;;;;;CAQC,wBAAwB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,kBAAkB;AACtB;AACA;CACC,cAAc;IACX,kBAAkB;AACtB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;AACb;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;CACpB,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;AACA,iCAAiC;AACjC,sCAAsC;AACtC,yCAAyC;AACzC,oCAAoC;AACpC;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,4EAAiD;AAClD;;AAEA;CACC,iBAAiB;CACjB,QAAQ;CACR,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,2EAAiD;AAClD;AACA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,4EAAiD;AAClD;AACA;CACC,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,2EAAiD;AAClD;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4EAAkD;AACnD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,0FAAgE;AACjE;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;AACA;;AAEA,SAAS;;AAET,iBAAiB;;AAEjB;CACC,WAAW;CACX,aAAa;CACb,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,aAAa;CACb,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,aAAa;CACb,cAAc;CACd,iBAAiB;CACjB,4BAA4B;CAC5B,0BAA0B;CAC1B,cAAc;CACd,uBAAuB;CACvB,iBAAiB;CACjB,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,YAAY;CACZ,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA,SAAS;;AAET;CACC,YAAY;CACZ,oDAAoD;AACrD;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;CAGC,mBAAmB;CACnB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;CACvB,iCAAiC;CACjC,sCAAsC;AACvC;;AAEA;IACI,yEAA+C;IAC/C,kBAAkB;AACtB;;AAEA;;;;CAIC,cAAc;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;CACC,OAAO;IACJ,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,oDAAoD;IACpD,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;CACC,WAAW;AACZ;AACA;;GAEG;AACH;;;;;;;CAOC,aAAa;AACd;;AAEA;;;;;;;IAOI,6BAA6B;IAC7B,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sEAA4C;IAC5C,yDAAyD;IACzD,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wDAAwD;IACxD,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,0DAA0D;AAC9D;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,aAAa;CACb,cAAc;AACf;;AAEA;CACC,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,SAAS;CACT,uBAAuB;CACvB,aAAa;CACb,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;AACA;CACC,aAAa;AACd;;AAEA;;CAEC,cAAc;CACd,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,cAAc;AACf;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,yEAA+C;AAChD;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,YAAY;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;IAC3B,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;CACC,iBAAiB;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;KACrB,mBAAmB;KACnB,aAAa;KACb,oBAAoB;KACpB,WAAW;AAChB;;AAEA;KACK,WAAW;CACf,mBAAmB;AACpB;;AAEA;KACK,cAAc;IACf,gBAAgB;IAChB,WAAW;CACd;;CAEA;KACI,iBAAiB;KACjB,aAAa;KACb,oCAAoC;CACxC;;CAEA;KACI,UAAU;KACV,iDAAiD;CACrD;;AAED;CACC,qBAAqB;AACtB;;AAEA;CACC,eAAe;AAChB","sourcesContent":["/* Copyright (c) 2004-2013 IBM and others. All Rights Reserved. */\n/* Made with CSSEdit and Espresso2 */\n@charset \"UTF-8\";\n\n/* TODO: should load this locally via webpack, see https://unicode-org.atlassian.net/browse/CLDR-9195 */\n@import url(\"//fonts.googleapis.com/css?family=Noto+Sans:400italic,700italic,400,700\");\n@import url(\"//fonts.googleapis.com/css?family=Noto+Sans+Symbols:400italic,700italic,400,700\");\n@import url(\"//fonts.googleapis.com/css?family=Noto+Nastaliq+Urdu\");\n\n@import url(\"https://fonts.googleapis.com/css2?family=Noto+Sans+Sunuwar&display=swap\");\n\nspan.age  {\n\tfont-weight: bold;\n\tfont-style: italic;\n}\n\nul.adminList  {\n\tdisplay:  table-row;\n\tborder: 1px solid gray;\n}\n\nul.adminList li {\n\tdisplay:  table-cell;\n\tpadding:  0.5em;\n}\n\nul.adminList li.selected {\n\tborder-left:  1px solid gray;\n\tborder-right:  3px solid gray;\n\tborder-top:  1px solid gray;\n\tbackground-color: whitesmoke;\n\tbox-shadow: 3px 0px 5px gray;\n}\n\nul.adminList li.notselected {\n\tbackground-color: #eee;\n\tborder-left:  1px solid #ddd;\n\tborder-right:  1px solid #ddd;\n}\n\n.transcript-container {\n\tdisplay: none;\n}\n\n.transcript-container.visible {\n\tdisplay: block;\n}\n\na.show-transcript {\n\tfloat: right;\n}\n\npre.transcript-text {\n\tfont-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n\tfont-size: small;\n\twhite-space: pre-line;\n\tword-break: normal;\n}\n\n#small_login_shower button {\n    float:  right;\n}\n\ndiv.adminPanel {\n\tborder:  1px solid gray;\n\tbox-shadow: 3px 3px 5px gray;\n\tpadding:  2px;\n}\n\nh3.adminTitle {\n\tfont-size: x-large;\n\tborder-bottom:  2px solid black;\n}\n.userlist .seenSub::before {\n    content: 'Activity';\n    font-size: xx-small;\n}\n.userlist .seenSub {\n    display: block;\n    margin-top:  0.5em;\n}\n\n.userlist .seenSub .chartRow{\n    display:  table-row;\n}\n.userlist .seenSub .chartRow span{\n    display:  table-cell;\n    font-size: small;\n    padding-right: 0.25em;\n}\n\n.seenSub .chartDay {\n    white-space: nowrap;\n}\n.seenSub .chartLoc {\n    font-family: \"Courier New\", Courier, mono;\n}\n.seenSub .chartCount {\n    font-family: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;\n    text-align: right;\n}\n\n.userlist .chartMore {\n    float: right;\n    border: 1px solid black;\n    padding:  2px;\n    margin:  1px;\n    background-color: silver;\n    display: run-in;\n}\n\n.userlist div.adminUserUser {\n    padding: 0;\n    margin: 0;\n}\n\ndiv.adminUserUser i {\n\tfont-weight: normal;\n\tfont-style: normal;\n\tfont-variant: small-caps;\n\tfloat:  right;\n\tcolor: white;\n\tbackground-color: black;\n\tmargin:  0.5em;\n\tpadding:  3px;\n}\n\n.adminUserUser img {\n    margin-top:  0.25em;\n    margin-left:  0.25em;\n    margin-right:  0.25em;\n    float: left;\n}\n\n.adminSettingsList {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.adminSetting {\n    display: table-row;\n    background-color: #fcf8e3;\n}\n\n.adminSetting input {\n\twidth: 90%;\n\tdisplay: block;\n}\n\n.adminSetting label {\n\tfont-size: small;\n}\n\n#specialHeader {\n\tdisplay: block;\n    padding: 0.25em;\n    color:  black;\n    background-color: #fcf8e3;\n    opacity: 1;\n\tfont: italic  small Georgia, \"Times New Roman\", Times, serif;\n\tmargin-top:  2px;\n\tbox-shadow: 1px 1px 1px gray;\n}\n.adminSettingId, .adminSettingValue {\n    display: table-cell;\n    padding:  2px;\n    border-bottom:  1px dashed gray;\n}\n\n.adminSettingId {\n\tfont-weight: bold;\n\tpadding-right: 1em;\n}\n\n.adminSettingValue {\n\tpadding-bottom:  1px;\n\tfont-family: \"Courier New\", Courier, mono;\n\tfont-size:  small;\n}\n\n.debugStuff {\n\tfont-family: monospace,\"Courier New\", Courier, mono;\n\tfont-size:  small;\n\tpadding:  0.25em;\n\tbackground-color:  white;\n\tborder:  3px groove green;\n\tbox-shadow: 3px 3px 2px gray;\n}\n\n.userlist .noActivity a.recentActivity {\n    opacity:  0.5;\n}\n\n.userlist .hadActivity a.recentActivity {\n    font-weight: bold;\n    opacity:  1.0;\n    color:  white;\n    background-color:  navy;\n}\n\n.userlist  .noActivity .adminUserUser {\n    opacity:  0.75;\n}\n.userlist  .hadActivity .adminUserUser {\n    border:  2px solid black;\n}\n\ni.userlevel_guest {\n\tbackground-color: navy !important;\n\tcolor:  white !important;\n}\ni.userlevel_vetter {\n\tbackground-color: green !important;\n\tcolor:  black !important;\n}\ni.userlevel_locked {\n\tbackground-color: gray !important;\n\tcolor:  silver !important;\n}\ni.userlevel_manager{\n\tbackground-color: #e77de7 !important;\n\tcolor: white !important;\n}\ni.userlevel_admin {\n\tbackground-color: maroon !important;\n\tcolor:  silver !important;\n}\ni.userlevel_tc {\n\tbackground-color: orange !important;\n\tcolor:  black !important;\n}\n\n\n/* todo: replace w/ icons */\n\n\ndiv.adminUser {\n\tmargin:  1em;\n\tborder:  1px solid gray ;\n\twidth:  50em;\n\tbackground-color: #e3e3e3;\n}\n\nspan.adminUserSession {\n\tfont: small Georgia, \"Times New Roman\", Times, serif;\n\ttext-align: left;\n\tfloat: right;\n}\n\nspan.adminUserInfo {\n\tfont-size: small;\n\ttext-align: right;\n\tmargin:  8px;\n}\n\n\ndiv.adminUserUser {\n\tbackground-color: #92c1c9;\n\twidth:  30em;\n\tmargin:  1em;\n}\n\ndiv.forumDiv div.adminUserUser {\n    width:  inherit !important;\n}\n\nspan.adminUserName {\n\tfont-size:  large;\n\tdisplay:  block;\n}\nspan.adminOrgName {\n\tfont-size: small;\n\tdisplay:  block;\n    font-style: italic;\n}\n\naddress.adminUserAddress {\n\tfont: normal smaller \"Courier New\", Courier, mono;\n    white-space: nowrap;\n}\n\n\n\nbutton.icancel {\n\tdisplay: none;\n}\n\nbutton.isubmit {\n\n\n}\n\nbutton.ichoice {\n\n}\n\nbutton.inochoice {\n\n}\n\n#explainIcons {\n\tfont-size: small;\n}\n\n/* @group Vetting View */\n\n/* todo: sync with later items */\n\ntable.tv-table, table.tvs-table {\n\tborder-collapse: collapse;\n}\n\ntable.tv-table, th.tv-th, tr.tv-tr, td.tv-num, td.tv-code, td.tv-eng, td.tv-last, td.tv-win, td.tv-fix, table.tvs-table, tr.tvs-tr, td.tvs-count, td.tvs-abb, td.tvs-desc, td.tv-test {\n\tborder: 1px solid gray;\n}\n\ntd.tv-num, td.tv-code, td.tv-eng, td.tv-last, td.tv-win, td.tv-fix, td.tvs-count, td.tvs-abb, td.tvs-desc {\n\tbackground-color: #FFFFCC;\n}\n\ntd.tv-num, td.tvs-count {\n\ttext-align: right;\n}\n\nth.tv-th, th.tvs-th {\n\tbackground-color: #DDDDDD;\n}\n\nth.tv-win {\n\tbackground-color: #FFCCCC;\n}\n\n/* @end */\n\ntd {\n\tvertical-align: top;\n}\n\nhr {\n\tborder: 1px dashed #ccd\n}\n\ntr.row0 {\n\tbackground-color: #fff\n}\n\ntr.row1 {\n\tbackground-color: #ddd\n}\n\nA.nodraft {\n\ttext-decoration: none\n}\n\nA.nodraft:link {\n\tcolor: #4567b0\n}\n\nA.nodraft:active {\n\tcolor: #f00\n}\n\nA.nodraft:visited {\n\tcolor: #8372d2\n}\n\n.draftl {\n\tfont-weight: bold;\n\ttext-decoration: none\n}\n\n.missing {\n\tbackground-color: #ffd8c8;\n\tborder: 1px solid red;\n}\n\n.missing a:link {\n\tcolor: #fff\n}\n\n.missing a:visited {\n\tcolor: #ddd\n}\n\n.missing a:active {\n\tcolor: #f00\n}\n\n.missing a:hover {\n\tcolor: #fDD\n}\n\n.xpath {\n\tfont-size: smaller;\n}\n\ndiv.search div.results h3, div.search div.results h4 {\n    display:  inline;\n    padding-right:  2em;\n}\n\ndiv.search div.results li {\n    display:  block;\n}\n\ndiv.search a.xpath {\n    display: block;\n    color:  gray;\n}\n\ndiv.search div.results li {\n    border-top:  1px solid silver;\n    list-style: none;\n    padding-bottom: 0.5em;\n}\n\ndiv.search div.results li a.codebox {\n    font-size:  larger;\n}\n\n.alias {\n background-color: #ddf;\n}\n\n.constructed {\n\tbackground-color: sandybrown;\n\tpadding: .1em .4em .2em;\n\tborder-style: groove;\n}\n\n.fallback {\n\tbackground-color:#5bc0de;\n\tpadding: .1em .4em .2em;\n\n}\n.fallback_root, .fallback_code {\n\tborder: 1px dotted #f00 !important;\n\tbackground-color: #FFDDDD ;\n}\n\n.draft {\n\tbackground-color: #88FFAA  !important;\n}\n\n.proposed {\n\tbackground-color: #88DDAA  !important;\n}\n\n.selected {\n\tfont-size: 120%;\n\tfont-weight: bold;\n\tcolor: #313998;\n}\n\na.selected :link {\n\tcolor: #fff\n}\n\n.notselected {\n\tmargin: 2px;\n\tpadding: 1px;\n}\n\na.notselected {\n\tcolor: #358cc3;\n\ttext-decoration: underline;\n}\n\ndiv.adminThreads {\n\tdisplay:  table;\n}\n\ndiv.adminThreadList,\ndiv.adminExceptionList {\n\twidth:  43%;\n\tclear:  right;\n\tpadding-right:  1em;\n\tdisplay:  table;\n}\n\n.adminExceptionFooter {\n\tpadding: 0.25em;\n\tfont-style: oblique;\n\tdisplay: block;\n\tclear: both;\n\tpadding-bottom: 0.5em;\n\tfloat: right;\n}\n\ndiv.adminThreadList span {\n\tdisplay:  table-cell;\n}\n\nspan.adminExceptionHeader {\n\tfont-weight: bold;\n\tfont-family: Georgia, \"Times New Roman\", Times, serif;\n\tdisplay:  block;\n}\n\nspan.adminExceptionUptime {\n\tdisplay: block;\n\tcolor: darkgreen;\n\tfont-family: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;\n}\n\n#adminStuff div.adminPanel div.adminThreads div.adminThreadStack pre.adminExceptionSTACK {\n\tpadding-left:  2em;\n\tpadding-top: 0;\n\tmargin-top: 0;\n}\n\n.deadThread, .adminDeadThreadsHeader, ul.adminDeadThreads {\n    background-color: red;\n    color: black;\n}\n.adminDeadThreadsHeader {\n    padding-left: 30px;\n    margin:0;\n    white-space: nowrap;\n    background: url(stop.png) no-repeat 0 top;\n    display: block;\n}\n\nul.adminDeadThreads {\n    display: inline;\n    padding-left: 40px;\n    margin:0;\n    margin-bottom: 1em;\n}\n\nul.adminDeadThreads li {\n    display: inline;\n    padding-left: 0.25em;\n}\n\n.adminThreadStack {\n    vertical-align: top;\n}\n\npre.adminExceptionLogsite {\n    padding-left:  20px;\n    background: url(conf2.png) no-repeat 0 top;\n}\n\npre.adminExceptionSQL {\n\tpadding-left:  20px;\n\tbackground: url(squo.png) no-repeat 0 top;\n\tfont: italic bold large \"Courier New\", Courier, mono;\n}\n\npre.adminExceptionMESSAGE {\n\twhite-space: normal;\n\tborder-top: 2px solid gray;\n\tfont-weight: bold;\n\tfont-family: Georgia, \"Times New Roman\", Times, serif;\n\tbackground: url(stop.png) no-repeat 0 top;\n\tpadding-left:   20px;\n\tpadding-bottom: 0;\n\tmargin-bottom: 0;\n}\n\ndiv.adminException {\n\tdisplay: block;\n\tpadding-top:  0.25em;\n\tpadding-bottom:  1.5em;\n\tborder-bottom:  1px solid whitesmoke;\n}\n\ndiv.adminException span {\n\tdisplay:  block;\n}\n\ndiv.adminException span.adminExceptionHeader {\n\tdisplay:  block;\n\tpadding-left:  20px;\n\tbackground: url(stop.png) no-repeat 0 top;\n}\n\nspan.adminExceptionDate {\n\twhite-space: nowrap;\n\tfont: small \"Lucida Grande\", Lucida, Verdana, sans-serif;\n\tfloat: right;\n\tdisplay: block\n}\n\nspan.adminThreadse_RUNNABLE {\n\tbackground-color: lime;\n}\n\nspan.adminThreadState_WAITING {\n\tbackground-color: lightgreen;\n}\nspan.adminThreadState_BLOCKED {\n\tbackground-color: red;\n}\nspan.adminThreadState_TIMED_WAITING {\n\tbackground-color: silver;\n}\n\n.adminExceptionCount {\n\tpadding-left:  20px;\n\tbackground: url(zoom.png) no-repeat 0 top;\n\ttext-decoration: underline;\n}\n\n.adminExceptionMore {\n\tcolor: maroon;\n}\n\n.adminExceptionCount:hover,\ndiv.adminException span.adminExceptionHeader:hover {\n\tcolor: blue;\n}\n\ndiv.adminThread {\n\tborder-bottom:  1px dotted gray;\n\tdisplay:  table-row;\n\tpadding-right: 0.5em;\n}\n\n\nspan.adminThreadId {\n\twidth:  5em;\n\tpadding-right:  1em;\n}\n\nspan.adminThreadName {\n\tborder-bottom: 1px solid silver;\n}\n\nspan.adminThreadState_RUNNABLE,\nspan.adminThreadState_TIMED_WAITING,\nspan.adminThreadState_WAITING,\nspan.adminThreadState_BLOCKED {\n\ttext-align: right;\n\tfont-size: small;\n\tfont-weight: bold;\n}\n\ndiv.adminThreadStack {\n\tdisplay:  inline;\n\twhite-space: pre;\n\twidth: 43%;\n\tdisplay:  table-cell;\n\tfont: small \"Courier New\", Courier, mono;\n\tbackground-color: #fcf8e3;\n\tpadding:  3px;\n}\n\n.textForTrac {\n\tbackground-color: #fcf8e3;\n\tcolor: #fcf8e3;\n\tfont-size: 1px;\n}\n\n.clickToSelect {\n\tdisplay: block;\n\tclear: both;\n\tfloat: right;\n}\n\ndiv.adminThreadStack b, span.adminThreadName {\n\tfont-family: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;\n}\n\n.sep {\n\theight: 3px;\n\toverflow: hidden;\n\tbackground-color: #44778C;\n}\n\n.name {\n\tbackground-color: #eef;\n}\n\n.warning {\n\tfont-size: smaller;\n\t/*\tfont-color: #F22;\n\t*/\n\tcolor: #F22;\n\tbackground-color: #fee;\n\tborder: 1px solid red;\n}\n\n.warningReference {\n\tfont-family: \"Lucida Grande\", Lucida, Verdana, sans-serif;\n\tcolor: teal;\n}\n\n.warningTarget {\n\tfont-family: \"Lucida Grande\", Lucida, Verdana, sans-serif;\n\tcolor: teal;\n}\n\ntd.warncell {\n\tborder-left: 1px solid #ddd;\n}\n\ntr.warnrow {\n\t/*    font-color: #f22;\n\t*/\n    color: #f22;\n\tbackground-color: #fee;\n}\n\n.pager {\n\tborder: 1px solid gray;\n\tbackground-color: #FFEECC;\n\tpadding: 0.2em 0.2em 0.2em 0.2em;\n\n\n/*\tpadding: 1em 1em 1em 1em; */\n\tmargin-top: 2px;\n\tfont-size: smaller;\n}\n\n.pagerln {\n\tborder-bottom: 1px solid #aaa;\n\tborder-top: 1px solid #aaa;\n}\n\n.pagerl_active {\n\n}\n\n.pagerl_inactive {\n\tcolor: gray;\n}\n\n.localenav {\n\tborder: 1px solid gray;\n\tbackground-color: #fff;\n\tmargin: 5px;\n/*align: left;*/\n}\n\n.localeList {\n    width:  auto;\n}\n\n.localeList .topLocaleRow {\n    width:  auto;\n}\n\n.topLocale a {\n    white-space: nowrap;\n    font-weight: bold;\n    font-size:  larger;\n}\n\n.localeList a:hover {\n    color:  red !important;\n}\n\n.topLocaleRow .topLocaleDiv {\n    display:  table-cell;\n}\n.topLocaleRow .subLocaleList {\n    display:  block;\n    padding-left:  4em;\n}\n\n.subLocaleList .subLocale {\n    margin-right:  0.25em;\n    display: inline-block;\n}\n\n.topLocaleRow a {\n\tdisplay:block;\n\tpadding-right: 12px;\n\tpadding-top:6px;\n\tpadding-bottom:6px;\n\tpadding-left:5px;\n    -webkit-transition: all 0.5s ease;\n    -moz-transition: all 0.5s ease;\n    -ms-transition: all 0.5s ease;\n    -o-transition: all 0.5s ease;\n    transition: all 0.5s ease;\n}\n\n.topLocaleRow a:hover {\n\tbackground-color:#446e9b;\n\tcolor:white !important;\n\ttext-decoration: none;\n}\n\n.scratch_locale a::after {\n\tcontent: \" (TEST) \";\n}\n\n.subLocale a.locked.locName, .topLocaleRow a.locked.locName {\n    color:  silver;\n}\n\n.canmodify::before {\n\tcontent:\"\\270f  \"; /* pencil */\n\tfont-family: 'Glyphicons Halflings';\n}\n\n.locked::before {\n    font-family:\"Glyphicons Halflings\";\n    content:\"\\e014 \";  /* X */\n    margin-top:2px;\n}\n\n.name_var {\n    font-style: oblique;\n}\n\n.inputbox {\n\twidth: 95%;\n}\n\n.inputboxbig {\n\twidth: 95%;\n}\n\n.badinputbox {\n\tborder: 2px dashed red;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.hang {\n\ttext-indent: -2em;\n\tpadding-left: 2em;\n\tmargin-bottom: .4em;\n\tmargin-top: .4em;\n}\n\n.hangsml {\n\ttext-indent: -1em;\n\n\n/*\n\nmargin-left: 2em; */\n}\n\ntable.list {\n\tborder-collapse: collapse;\n\tdisplay: inline;\n}\n\ntable#statisticsTable {\n    border-collapse: collapse;\n}\n\n#statistics_area {\n\twidth: 80%;\n\theight: 400px;\n/*    overflow: scroll;*/\n\tborder: 1px solid gray;\n\tmargin-bottom: 1em;\n}\n\ntable#statisticsTable thead th {\n    font-weight: bold;\n    border-bottom: 1px solid gray\n}\n\ndiv.statistics h2 {\n\tborder-top: 2px solid gray;\n\twidth: 100%;\n\tmargin-top: 2em;\n}\n\ndiv.statistics {\n    margin-left: 1.5em;\n}\n\ndiv.dijitTooltipContainer.dijitTooltipContents {\n    box-sizing: inherit !important;\n}\n\ndiv.statistics .swatch {\n\tborder: 1px solid black;\n\twidth: 1em;\n\theight: 1em;\n\tmargin: 0.25em;\n\twhite-space: pre;\n}\n\ndiv.statistics .color0 {\n\tbackground-color: #8aa717;\n}\n\ndiv.statistics .color1 {\n\tbackground-color: #1751a7;\n}\n\ntable#statisticsTable td.locid {\n    font: bold small \"Courier New\", Courier, mono;\n    text-align: right;\n}\n\ntable#statisticsTable a {\n    text-decoration: none;\n}\n\ntable#statisticsTable td.locname a,\ntable#statisticsTable td.selfname.dirltr a {\n    padding-left:  18px;\n}\n\ntable#statisticsTable td.selfname.dirrtl a {\n    padding-right:  18px;\n}\n\n\ntable#statisticsTable td.locname a:hover {\n    background: url(zoom.png) no-repeat;\n    text-decoration: underline;\n}\n\ntable#statisticsTable td.selfname.dirltr a:hover\n{\n    background: url(dnah.png) left no-repeat;\n    text-decoration: underline;\n}\ntable#statisticsTable td.selfname.dirrtl a:hover\n{\n    background: url(hand.png) right no-repeat;\n    text-decoration: underline;\n}\n\ntable#statisticsTable .olddata {\n    opacity: .8;\n    color: #1561b7;\n}\n\ntable#statisticsTable .olddata:hover {\n    color: red;\n}\n\ntable#statisticsTable tbody tr.r0 {\n\n}\ntable#statisticsTable tbody tr.r1 {\n    background-color: #d2eee1;\n}\n\ntable#statisticsTable tbody tr:hover {\n    background-color: #ecd290;\n}\n\ntable#statisticsTable td.count {\n    text-align: right;\n}\n\ndiv.minimenu {\n\tborder-collapse: collapse;\n\tborder-top: 1px solid black;\n\tbackground-color: #ddf;\n}\n\ndiv.minimenu a.forumlink {\n\tfloat: right;\n}\n\nh2.thisItem {\n\tmargin-top: 0;\n\tfont-family: Georgia;\n\tfont-size: x-large;\n\tbackground-color: #ddf;\n\ttext-align: center;\n}\n\n.small_login_hidden {\n\tdisplay: none;\n}\n\ni.loadingMsg,\ni.loadingMsgSpin {\n\tfont-size: xx-large;\n\ttext-align: justify;\n\tfont-weight: bold;\n\t/* text-transform: uppercase; */\n\tcolor: black;\n\tfont-style:normal;\n}\n\ni.loadingMsgSpin {\n\twhite-space: pre;\n\tfont-family: monospace;\n}\n\n/*\n#LoadingMessageSection::after {\n\tcontent: url('loader.gif');\n\tposition:relative;\n\ttop:10px;\n\tleft:15px;\n}\n*/\n\n\n.loaderAnimIcon {\n\tbackground-image: url('loader.gif');\n\tbackground-repeat: no-repeat;\n\tposition:relative;\n\ttop:10px;\n\tleft:15px;\n\twidth: 100px;\n\theight: 100px;\n}\n\n.small_login_hot {\n\tfont-size: larger;\n\tborder: 7px outset maroon;\n\tbackground-color: #fad084;\n\tpadding: 2.0em;\n\ttext-shadow: #000000 0 0 0;\n\tposition: absolute;\n\ttop: 25px;\n\tright: 0;\n\tz-index: 4;\n\tline-height: 1.34em;\n}\n\n.serverLoadInfo {\n    margin-top:  5em;\n    font: normal normal small \"Lucida Grande\", Lucida, Verdana, sans-serif;\n}\n\ndiv#smalllogin {\n\n}\n\n.small_login_visible {\n\n\n/*opacity: 1;*/\n\tdisplay: inline;\n/*\n\nvisibility:  visible;*/\n}\n\ni.scary {\n\tcolor: #f9514d;\n\tfont: normal normal x-small ocra10,Anaktoria;\n}\n\n.list.td .list.th {\n\tpadding-top: 3px;\n\tpadding-bottom: 4px;\n}\n\n.listb {\n\tborder: 1px solid black;\n\tborder-collapse: collapse\n}\n\n.listb.td .listb.th {\n\tpadding-top: 3px;\n\tpadding-bottom: 4px;\n}\n\ntable.list tr.row0 {\n\tbackground-color: #fff\n}\n\ntable.list tr.row1 {\n\tbackground-color: #edf3fe\n}\n\ntable.list tr.heading {\n\tbackground-color: #dcfed2;\n\tcolor: #791830;\n\tborder-bottom-style: solid;\n\tborder-bottom-color: #c9c9c9;\n}\n\ntable.userlist th {\n\tcolor: navy;\n\tfont-size: 92%;\n}\n\ntable.userlist td {\n\ttext-align: left;\n}\n\n.user0 {\n\tborder-color: maroon;\n\tborder-color: maroon;\n\tcolor: maroon;\n\tbackground: #ffd3bb;\n}\n\n.userlist {\n\tborder-collapse: collapse;\n\ttext-align: left;\n}\n\ntable.userlist {\n\tmargin-top: 4px;\n\tmargin-bottom: 4px;\n\tborder-style: outset;\n\ttext-align: left;\n}\n\n.voteDiv p {\n\tmargin: 2px;\n}\n\n.topbar {\n\tborder-top: 3px solid #040;\n}\n\n.botbar {\n\tborder-bottom: 3px solid #040;\n}\n\nth.botgray {\n\tborder-bottom: 1px solid #ddd;\n}\n\ntd.botgray {\n\tborder-bottom: 1px solid #ddd;\n}\n\ntd.topgray {\n\tborder-top: 1px solid #ddd;\n}\n\ntr.warningRow td {\n\tborder-top: 1px solid #222;\n\tborder-bottom: 1px solid #222;\n}\n\ntr.referenceRow td {\n\tborder-top: 1px solid #222;\n\tborder-bottom: 1px solid #222;\n}\n\ntr.heading {\n\tbackground: #ddd;\n}\n\ntr.heading th.partsection {\n\tborder-top: 2px solid black;\n\tz-index: 0;\n}\n\nth.partsection {\n\tborder-top: 2px solid gray;\n\tpadding: 0.5em;\n}\n\n.userlist th.partsection {\n\tborder-top: 2px solid gray !important;\n\tpadding: 0.5em !important;\n\tbackground: silver;\n}\n.userlist th.partsection  h4{\n\tmargin: 0;\n}\n\nth.partsection, th.partsection a {\n\tfont-weight: bold;\n\tfont-style: italic;\n\tbackground-color: #d9edf7;\n\tcolor: #111111;\n\ttext-align: left;\n\tz-index: 0;\n    text-transform: capitalize;\n}\n\ntt.codebox {\n\tborder: 1px solid gray;\n}\n\n.respbox {\n\tborder: 1px solid gray;\n\tpadding: 0.5em;\n}\n\ndiv.respbox:target {\n\tborder: 4px solid goldenrod !important;\n\tpadding: 1em;\n}\n\n.respbox h3, .respbox h3 a {\n\tcolor: #084610;\n\tmargin: 2px;\n}\n\n.person {\n\tfloat: right;\n\tclear: none;\n\tfont-size: smaller;\n\ttext-align: right;\n}\n\ndiv.person a {\n\tfloat: none;\n}\n\n.localeName {\n    display:  block;\n    font-size: medium;\n}\n\n.topicSubject {\n    font-family: Georgia, \"Times New Roman\", Times, serif;\n    font-weight:  bold;\n}\n\n.forum-me {\n    font-weight:  bold;\n    font-size:  larger;\n}\n\n.post {\n    margin-bottom: 0.75em;\n    padding-bottom:  0.25em;\n-webkit-transition: all 0.5s ease;\n-moz-transition: all 0.5s ease;\n-ms-transition: all 0.5s ease;\n-o-transition: all 0.5s ease;\ntransition: all 0.5s ease;\n}\n\n.post, .post .postReplies {\n    background-color: #f4f5f4;\n}\n\n\n.postReplies .post {\n    margin-top: 1em;\n}\n\n.postContent {\n    white-space: pre-wrap;\n}\n\n.postContent button {\n    margin-left: 1em;\n    margin-top:  0.5em;\n}\n\n.selectedPost {\n\tborder-left-color: #eca92e;\n\tborder-left-width: 2em;\n\tborder-left-style: solid;\n\tpadding-left: 1em;\n}\n\n.reply a, div.subpost a.postReply {\n\tbackground-color: #fff88d;\n\tmargin-bottom: 1em;\n}\n\ndiv.subpost a.postReply {\n\ttext-align: right;\n}\n\n.odashbox {\n\tborder: 3px dashed olive;\n\tmargin: 1em;\n\tpadding: 1em;\n}\n\n.dashbox {\n\tcolor: #000;\n\tbackground: #ddd;\n\tfont-size: 80%;\n\tborder: 1px dashed gray;\n\tpadding: 1px;\n\tmargin-top: 0px;\n}\n\n.actionbox {\n    font-size: 80%;\n}\n\na.forumlink {\n\tpadding-left: 1em;\n\tbackground: url(chat.png) no-repeat;\n}\n\ntd.d-code.hasPosts {\n\tbackground: url(chat.png) no-repeat right bottom;\n}\n\ndiv.forumDiv div.subpost {\n\tbackground-color: #f5e3c2;\n\tmargin-top:  0.25em;\n\tpadding:  0.25em;\n}\n\ndiv.forumDiv div.subpost b {\n\tmargin-right: 1em;\n\tdisplay:  table-cell;\n\tpadding-right:  1em;\n}\n\ndiv.forumDiv div.subpost .postHeader {\n\tdisplay:  table-cell;\n}\n\nbutton.forumNewPostFlagButton {\n    padding-left: 2em;\n    background: url(flag-d.png) no-repeat left center;\n}\n\nbutton.forumNewPostFlagButton:hover {\n    padding-left: 2em;\n    background: url(flag.png) no-repeat left center;\n}\n\ndiv.forumDiv .adminUserUser {\n\tbackground-color: lightgrey !important;\n\tmargin: 3px !important;\n\tdisplay:  block !important;\n}\ndiv.forumDiv span.adminUserName {\n\tfont-size:  medium !important;\n}\ndiv.forumDiv .adminUserUser span.adminUserName,\ndiv.forumDiv  .adminUserUser address,\ndiv.forumDiv .adminUserUser i {\n\t\tfloat:none !important;\n\t\tmargin:  0.25em !important;\n}\n\ndiv.forumDiv div.subpost div.postContent {\n\tpadding-top:  0.5em;\n\tfont: small Georgia, \"Times New Roman\", Times, serif;\n\twhite-space: pre-wrap;\n}\n\ndiv.postReplies {\n\tmargin-left: 0.5em;\n\tpadding-left: 0.5em;\n\tpadding-top:  0.25em;\n\tmargin-top:  0.25em;\n}\n\n.forumLink {\n    text-decoration: underline;\n}\n\n.forumLink:hover {\n    color: blue;\n    background-color: white;\n    cursor:  pointer;\n}\n\ndiv.postReplies,\ndiv.postReplies:hover > div.post > div.postReplies {\n\tborder-left: 3px solid gray;\n}\n\ndiv.postReplies .post {\n    margin-top: 0.25em;\n}\n\ndiv.postReplies:hover > div.post > div.postReplies:hover,\ndiv.postReplies:hover\n {\n    border-left:  3px solid red;\n}\n\n\na.postItem {\n\tmargin-left: 0.25em;\n}\n\n.disabledbox {\n\tfont-size: 80%;\n\tcolor: #555;\n}\n\n.deactivated {\n\tcolor: #555;\n}\n\ntd.framecell {\n\tborder: ridge #ffb000 4px;\n\tbackground: #f6ffe8;\n\tcolor: black;\n}\n\n/* @group vetting */\n\n.approved {\n\tborder-color: green;\n\tborder-style: ridge;\n\tmargin: 1px;\n\tpadding: 1px;\n}\n\n/* but, an insufficient table.. */\n\ntd.insufficient {\n\tborder: none;\n}\n\ntd.insufficient span.loser {\n\tborder: 2px;\n\tborder-color: #f0961b;\n\tborder-style: dashed;\n\tmargin: 1px;\n\tpadding: 1px;\n}\n\n\n.extraAttribute_heading {\n\n}\n.extraAttributes .extraAttribute {\n\tdisplay: inline;\n\tmargin: 1em;\n}\ntd.d-code .extraAttribute  {\n\tdisplay: block;\n}\n.extraAttribute {\n\tfont-family: Georgia, \"Times New Roman\", Times, serif !important;\n\tborder: 1px solid purple;\n\tbackground-color: #ddf;\n}\n\n/* @end */\n\n/* @group tzbox */\n\ntable.tzbox {\n\tborder-collapse: collapse;\n}\n\ntable.tzbox th {\n\tborder-right: 1px solid gray;\n\tborder-left: 1px solid gray;\n\tborder-bottom: 2px solid gray;\n\tcolor: black;\n}\n\ntable.tzbox td {\n\tpadding-right: 0.2em;\n\tpadding-left: 0.2em;\n\tborder-right: 1px solid gray;\n\tborder-left: 1px solid gray;\n}\n\ntable.tzbox tr.r0 td {\n\tcolor: #555;\n}\n\ntable.tzbox tr.r1 td {\n\tcolor: #555;\n\tbackground-color: #fe9;\n}\n\ntable.tzbox tr.r0currentZone td {\n\tcolor: black;\n\tbackground-color: white;\n}\n\ntable.tzbox tr.r1currentZone td {\n\tcolor: black;\n\tbackground-color: #fe9;\n}\n\ntable.tzbox tt.codebox {\n\tbackground-color: white;\n}\n\n/* @end */\n\n/* @group sqlbox */\n\ntable.sqlbox {\n\tborder: 1px solid gray;\n\tborder-collapse: collapse;\n}\n\ntable.sqlbox th {\n\tborder-right: 1px solid gray;\n\tborder-left: 1px solid gray;\n\tborder-bottom: 2px solid gray;\n\tcolor: navy;\n\tfont-size: 50%;\n\tbackground-color: #dde;\n}\n\ntable.sqlbox td {\n\tpadding-right: 0.2em;\n\tpadding-left: 0.2em;\n\tborder-right: 1px solid gray;\n\tborder-left: 1px solid gray;\n}\n\ntable.sqlbox tr.r0 td {\n\tcolor: black;\n}\n\ntable.sqlbox tr.r1 td {\n\tcolor: black;\n\tbackground-color: #fe9;\n}\n\n/* forms here don't need a margin */\n\ntable.sqlbox input {\n\tmargin: 0;\n}\n\ntable.sqlbox form {\n\tmargin: 0;\n}\n\n/* @end */\n\n.manageSubpages {\n\tpadding-left: 2em;\n\tdisplay: block;\n\twidth: 50em;\n}\n\n.manageSubpages a,\n.manageSubpages b {\n    display:  block;\n    border-radius: 5px;\n    border:  1px solid gray;\n    padding: 0.25em;\n    color:  blue;\n}\n\n.manageSubpages a:hover,\n.manageSubpages b:hover {\n    background: silver;\n    color: red;\n}\n\n#st-run-gui > .ferrbox {\n\twidth: 90%;\n\tpadding-left: 3em;\n\tpadding-bottom: 1em;\n\tfont-size: x-large;\n}\n\n.ferrbox {\n\tbackground-color: #ddd;\n\tborder: 1px solid red;\n\tmargin: .4em;\n\tpadding: .2em;\n}\n\ndiv#toparea {\n\tborder-bottom: 3px solid #e9f6e9;\n\tbackground-color: whitesmoke;\n\tfont: normal 1.2em Georgia, \"Times New Roman\", Times, serif;\npadding: 0;\n}\n\n.stNormalPage #toparea {\nmargin-top:  1em;\n}\n\ndiv#toparea img#stlogo {\n\tfloat: right;\n\tmargin-left: auto;\n\theight: 2.5em;\n\tmargin-right: 5.5em;\n\tpadding-top:  8px;\n\tdisplay: none;\n}\n\n.normal-title {\n\tfont-weight:  bold;\n}\n\n.dcbox {\n\tmargin-left:  0.3em;\n\tbackground-color: #ddd;\n\tpadding:  0.1em;\n}\n\n.dcbox .dchelp {\n\tpadding-left:  0.25em;\n\tfont-style: italic;\n}\n\n.sterrmsg {\n\tbackground-color: #ddd;\n\tborder: 1px solid red;\n\tmargin: 1em;\n\tpadding: 1em;\n}\n\n.deletebox {\n\tfont-size: small;\n\tmargin-left: 1px;\n\tmargin-right: 1px;\n\tcolor: #d00;\n\tfont-weight: bold;\n\twhite-space: nowrap;\n}\n\n.unvotebox {\n\tfont-size: small;\n\tmargin-left: 1px;\n\tmargin-right: 1px;\n\tmargin-bottom: 2px;\n\tcolor: #00989e;\n\tfont-weight: bold;\n\twhite-space: nowrap;\n}\n\n.fnotebox {\n\tborder: 1px solid #94a694;\n\tmargin: 0.5em;\n\tpadding: 0.2em;\n\tpadding-left: 2em;\n\tbackground: #f5f5f5 url(warn.png) no-repeat 0.25em center;\n}\n\n.okayText {\n    padding-left: 2em;\n    background: #DDFFDD url(okay.png) no-repeat 0.25em center;\n}\n.squoText {\n    padding-left: 2em;\n    background: #DDFFDD url(squo.png) no-repeat 0.25em center;\n}\n.stopText {\n    padding-left: 2em;\n    background: #FFDDDD url(stop.png) no-repeat 0.25em center;\n}\n.warnText {\n    padding-left: 2em;\n    background: #e4dcd4 url(warn.png) no-repeat 0.25em center;\n    padding-top: 2px;\n    padding-bottom:  1px;\n    margin-bottom:  3px;\n}\n\n.nobg {\n\tbackground-color: inherit !important;\n}\n\na.dcLocale {\n\tcolor:  #555;\n\ttext-decoration: none;\n}\n\n.specialHeader {\n\tborder: 2px solid gray;\n\tmargin: 0.5em;\n\tpadding: 0.5em;\n\tfont: small \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;\n}\n\n.scorebox {\n\tfont-size: small;\n\tfont-style: italic;\n}\n\n.scorebox:before {\n\tcontent: '(';\n}\n\n.scorebox:after {\n\tcontent: ')';\n}\n\n/* @group voteinfo old - obsolete? */\n\ntable#voteinfo td {\n\tborder-right: none !important;\n\tborder-left: none !important;\n}\n\ntable#voteinfo th {\n\tbackground-color: #ddd;\n}\n\ntable#voteinfo tbody th:first-child {\n\ttext-transform: capitalize;\n}\n\ntable#voteinfo tbody th:first-child,\ntable#voteinfo thead th:first-child {\n\tbackground-color: #bbf;\n\tborder-right: 2px solid black;\n\tfont-weight: inherit;\n}\n\ntable#voteinfo thead th:first-child {\n\tfont-weight: bold;\n}\n\n/* @end */\n\n/* @group voteInfo_perValue */\n\n/* This is a global style used in several places in the ST\n\tNotably cldrSurvey.setLang() and also the <cldr-value> Vue control\n*/\n.cldrValue {\n\twhite-space: pre-wrap;\n\t/* See the the section below this one for language specific CSS, including specific\n\t\tfont overrides. */\n\tfont-family: \"Noto Sans\",\n\t\t\t\t\t\"Noto Sans Symbols\",\n\t\t\t\t\tsans-serif;\n}\n\n/* lang specific CSS */\n\n/*\nNOTE: See http://www.w3.org/International/questions/qa-css-lang\n\nThe the following can work here:\n:lang(de) {\n  font-family: UnifrakturCook;\n}\n\n*/\n\n/* Kashmiri and Urdu are typically in Nastaliq. Kashmiri in particular uses a letter that is\n   not rendered correctly in Noto Naskh (see CLDR-16595) */\n\n:lang(ks), :lang(ur) {\n\tfont-family: \"Noto Nastaliq Urdu\";\n}\n\n/* The following is directly includeable as per https://github.com/saturngod/mmwebfonts/issues/4 */\n@font-face {\nfont-family:'MON3 Anonta 1';\nsrc:local('MON3 Anonta 1'),url('//mmwebfonts.comquas.com/fonts/mon3.ttf');\n}\n\n/*\nUse padauk or MM3 if available, otherwise Mon3.\n*/\n:lang(my) {\n  font-family:padauk,Myanmar3,'MON3 Anonta 1';\n}\n\n:lang(hnj) {\n\tfont-family: \"NotoSerifNyiakengPuachueHmong-Regular\", \"Noto Serif NP Hmong\"\n}\n\n:lang(suz-Sunu) {\n  font-family: \"Noto Sans Sunuwar\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n}\n\n.voteInfo_perValue {\n\tdisplay:  inline-table;\n\tvertical-align: top;\n}\n\ndiv.voteInfo_noVotes.voteInfo_td {\n\twhite-space: nowrap;\n\tfont-style: italic;\n}\n\n.voteInfo_winningItem {\n\tmargin: 0 !important;\n\tpadding:  0 !important;\n\tborder:  none !important;\n\ttext-align: left;\n\tdisplay: inline-block;\n}\n\n.voteInfo_tr_heading {\n\tfont-weight:bold;\n}\n\n.voteInfo_valueTitle {\n\tfont-weight:bold;\n}\n.voteInfo_iconValue  {\n\tbackground-position: left top !important;\n\tpadding-left:  20px !important;\n\twidth:  inherit !important;\n\theight:  inherit !important;\n}\n\ndiv.voteInfo_orgColumn {\n\tfont-weight: bold;\n}\n\n.voteInfo_orgHeading  div.voteInfo_orgColumn{\n\tborder-top:  1px solid gray;\n}\n\n.voteInfo_td, div.voteInfo_iconBar  {\n\tpadding-left:  0.10em;\n\tpadding-right:  0.10em;\n    border-top:  1px solid gray;\n\tpadding-bottom: 2px;\n   \tpadding-top:2px;\n}\n\n.voteInfo_tr_heading td {\n\tborder-top: none;\n}\n\ndiv.voteInfo_iconBar {\n\tborder:  none !important;\n\tdisplay:inline-block;\n\theight:20px;\n\tposition:relative;\n\ttop:2px;\n}\n\n\n.voteInfo_voterInfo, .voteInfo_voteCount {\n\tborder-top:  1px solid gray;\n\toverflow: visible;\n\tpadding-left:4px;\n}\n\n.voteInfo_voterInfo {\n\twidth:100%;\n}\n\n.voteInfo_orgsVote {\n\tfont-weight: bold;\n\tpadding-right:3px;\n}\n\n.voteInfo_voteTitle {\n\tfont-size: 110%;\n\tfont-weight: bold;\n}\n.voteInfo_orgsNonVote {\n\tcolor: #333;\n\tfont-style: italic;\n\tpadding-left:10px;\n}\n\n/* @end */\n\ntd.generatedexample {\n\tborder-left: 1px solid silver;\n\tborder-right: 2px solid gray;\n}\n\ntable.innerPropItems td.generatedexample,\ntable.innerPropItems td.propcolumn {\n\tborder-left: none;\n\tborder-right: none;\n\twhite-space: nowrap;\n}\n\nth.rowinfo {\n\tfont-size: small;\n\tborder-right: 1px solid gray;\n\tbackground-color: #eee;\n}\n\na.refuri {\n\tcolor: #000;\n\tfont-size: smaller;\n}\n\nul.orgvotes {\n\tmargin: 0px;\n}\n\nul.orgvotes li {\n\tmargin: 0px;\n\tfont-size: small;\n\tlist-style-type: circle;\n\tlist-style-position: outside;\n}\n\nspan.marks {\n\tfont-size: smaller;\n\tbackground-color: #fff4c9;\n}\n\nspan.marks b {\n\tfont-size: x-small;\n\tbackground-color: #30f;\n\tcolor: #ffe4ca;\n\tmargin: 1px;\n\tpadding: 1px;\n\tborder: 1px solid green;\n}\n\ndiv.topnotices a {\n\tcolor: black;\n}\n\ndiv.topnotices p {\n\ttext-align: center;\n\tmargin: 0;\n\tpadding: 4px;\n}\n\ndiv.topnotices p.admin {\n\tbackground-color: red;\n}\n\ndiv#stchanged {\n\tdisplay: none;\n\tbackground-color: yellow;\n\tpadding: 3px;\n\tposition: fixed;\n\tmargin-left: 100px;\n\ttop: 0;\n\twidth: 50%;\n\topacity: .9;\n\tborder: 2px solid gray;\n}\n\ndiv.loading {\n\tbackground-color: whitesmoke;\n\tpadding: 3px;\n\tposition: fixed;\n\tmargin-left: 100px;\n\ttop: 0;\n\twidth: 50%;\n\topacity: 1;\n\tbackground-color: #FFEECC;\n\tborder: 5px outset gray;\n}\n\n.hidden {\n\tdisplay: none;\n}\n\np.errCodeMsg {\n    font-family: Georgia, \"Times New Roman\", Times, serif;\n    font-weight: normal;\n    font-style: normal;\n    margin-left:  3em;\n    margin-right:  3em;\n    border:  2px solid silver;\n\tfont-size: larger;\n\twhite-space: pre-line;\n\tpadding: 0.5em;\n\tbackground-color: #ecd290;\n}\n\np.errCodeMsg .fgred {\n\tcolor: red;\n}\n\n#LoadingMessageSection p.errCodeMsg button {\n    display:  inline-block;\n    margin-top: 1em;\n    font-size: larger;\n\tmargin-left: 0.5em;\n}\n\n.cldr_substituted {\n\tbackground-color: #ddd;\n    font-weight: normal;\n    font-style: normal;\n}\n\n.cldr_background_auto {\n\tbackground-color: #EAEAF2;\n    font-weight: normal;\n    font-style: normal;\n}\n\n\n.cldr_example {\n    border: 1px solid #66666E;\n\tmargin-top:-1px;\n\tpadding:1px;\n}\n\n/* set the direction using html dir, not CSS direction */\n.cldr_example_auto {\n    border: 1px solid #66666E;\n\tmargin-top:-1px;\n\tpadding:1px;\n\ttext-align: center;\n\tbackground-color: #EAEAF2;\n}\n\n/* set the direction using html dir, not CSS direction */\n.cldr_example_rtl {\n    border: 1px solid #66666E;\n\tmargin-top:-1px;\n\tpadding:1px;\n\ttext-align: center;\n}\n\ndiv.d-example {\n    font: small \"Lucida Grande\", Lucida, Verdana, sans-serif;\n    margin-top:7px;\n}\n\n/* bootstrap popover likes to force the alignment left, but we want it to follow the language */\n.popover .d-example-popover {\n\ttext-align: initial !important;\n}\n\n#stchanged_loc {\n\tfont-weight: bold;\n}\n\n.unofficial {\n\tbackground-color: goldenrod;\n}\n\ndiv.topnotices div.unofficial {\n\tpadding: 3px;\n\tposition: fixed;\n\ttop: 30px;\n\tright: 0;\n\topacity: 0.9;\n\ttext-align: center;\n\tdisplay: none;\n}\n\nbody > div.topnotices #betanotice {}\n\nbody > div.topnotices div.beta {\nclear: right;\nposition: fixed;\nleft: 0;\ntop: 0;\nz-index: 0;\n}\ndiv.beta {\n\t/*\n-webkit-transform: rotate(-90deg);\n\t-webkit-transform-origin: right bottom;\n\t-moz-transform: rotate(-90deg);\n\t-moz-transform-origin: right bottom;\n\t-o-transform: rotate(-90 deg);\n-o-transform-origin: right bottom;\n-khtml-transform: rotate (-90deg);\n-khtml-transform-origin: right bottom;\n*/\n/* filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3); */\n    opacity: 0.9;\n\tfloat: right;\n\tfont-size: smaller;\n\tmargin-top:  2px;\n\tmargin-left:  2px;\nbackground-color: yellow;\npadding:  2px;\npadding-top:  3px;\nbox-shadow: 1px 1px 1px gray;\nline-height:  12px;\nposition:fixed;\ntop:120px;\nright: 0%;\n}\n\nbody.claro div.beta {\n    position: fixed;\n    right: 0;\n    top: 0;\n}\n\n#betanotice img {\n    height:  50%;\n}\n\ndiv.debugJsp {\n\tposition: fixed;\n\tbottom: 0;\n\tright: 0;\n\tborder: 1px solid gray;\n\tmargin: 0.5em;\n}\n\nspan.elapsedtime {\n\tfont-size: smaller;\n}\n\nspan#visitors table {\n\tposition: absolute;\n\tright: 0;\n}\n\nspan#visitors table.stprogress {\n\tborder: 1px solid #ccc !important;\n}\n\nspan#visitors td.bar {\n\tbackground: #ddd !important;\n\tborder: none !important;\n}\n\nspan#visitors td.remain {\n\tbackground: #2e2 !important;\n\tborder: none !important;\n}\n\ntable.progress-list {\n\tborder-collapse: collapse;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n}\n\ntable.progress-busy {\n\tborder-bottom: 3px solid red;\n\tborder-right: 3px solid red;\n}\n\ntable.progress-idle {\n\tborder-bottom: 2px dashed green;\n\tborder-right: 2px dashed green;\n\topacity: 0.8;\n}\n\ntable.progress-list tr th {\n\tvertical-align: top;\n\tbackground-color: #eee;\n\topacity: .8;\n\tpadding-left: 1em;\n\tcolor: red;\n}\n\ntable.progress-list tbody tr td {\n\tbackground-color: #bbb;\n\topacity: .9;\n\tborder-left: 3px dashed gray;\n\tpadding-left: 1em;\n}\n\ntable.progress-list #busy0 {\n\tdisplay: block;\n}\n\n/* Overrides */\n\nspan#progress.popout table.progress-list td {\n\tdisplay: table-cell !important;\n}\n\nspan#progress.popout table.progress-list #busy0 {\n\tdisplay: none !important;\n}\n\nspan#progress.popout table.progress-list #busy1 {\n\tdisplay: block !important;\n}\n\ntable.progress-list tbody tr td:first-child {\n\topacity: 1.0;\n\tbackground-color: whitesmoke;\n\tborder-left: none;\n\tpadding-left: 0;\n}\n\ntable.stprogress {\n\tmargin: 5px;\n\tpadding: 0;\n\tborder-collapse: collapse;\n\tborder: 2px solid black;\n}\n\ndiv.vvprogress {\n\tdisplay: run-in;\n}\n\ndiv.vvprogress  div {\n\theight: 16px;\n\tdisplay: table-cell;\n}\n\ntable.stprogress td.bar, div.vvprogress div.bar{\n\tpadding: 0;\n\tmargin: 0;\n\tborder-left: 2px solid black;\n\tborder-right: 1px solid silver;\n\tbackground: #6c31fe url(bar0.png) repeat scroll left;\n}\n\ntable.stprogress td.remain, div.vvprogress div.remain {\n\tpadding: 0;\n\tmargin: 0;\n\tborder-left: none;\n\tborder-right: 2px solid black;\n\tbackground: #ddd url(bar1.png) repeat;\n}\n\nlabel.menutop-active {\n\tborder: 2px solid green;\n\tbackground-color: navy;\n\tcolor: white;\n}\n\nselect.menutop-active {\n\tmargin: 0;\n}\n\n/* visible menu, please.  */\nselect.menutop-other,\nselect.menutop-active\n {\n\tbackground-color: white;\n\tcolor: black !important;\n\tfont-weight: normal !important;\n}\n\n#sectionmenu {\n\tpadding-top:  0.5em;\n}\n\nlabel.menutop-active, label.menutop-other,\n#sectionmenu label {\n\tpadding-left: 0.5em;\n\tpadding-right: 0;\n\twhite-space: nowrap;\n}\n\n/* classes for ajax form responses */\n\n.user_email {\n font-size: small;\n\tfont-style: italic;\n}\n\n.user_name {\n\tcolor: navy;\n}\n\n.user_org {\n\tcolor:  navy;\n}\n\n/*\n * tr_checking1, tr_checking2:\n * A row temporarily changes its background color to indicate that the user has\n * initiated an action, such as voting for an item.\n * The color changes per tr_checking1 as soon as the user clicks.\n * The color changes per tr_checking2 when a response is received from the server.\n * The color changes back to normal after the response has been processed.\n * The classes tr_checking1, tr_checking2 are used not only to change the appearance,\n * but also to prevent the row from being updated when a multiple-row response is received;\n * see insertRowsIntoTbody.\n */\ntr.tr_checking1 {\n\tbackground-color: orange;\n\topacity: 0.5;\n}\n\ntr.tr_checking2 {\n\tbackground-color: #d4edd9; /* green */\n\topacity: 0.75;\n}\n\ntr.tr_warn {\n\tbackground-color: yellow;\n}\n\ntr.tr_err {\n\tbackground-color: red;\n}\n\n/*\n * tr_submit highlights a row when a dialog is open for submitting a new value.\n * Usually the position of the dialog is a good indicator of the row to which it corresponds. However,\n * if the row is near the top or bottom of the window, the dialog may be positioned higher or lower in\n * order to be completely visible. The distinctive style of the row may then help to avoid confusion.\n */\ntr.tr_submit {\n\tbackground-color: #dfd; /* pale green */\n}\n\ndiv.v-oldVotes-subDiv {\n    margin-left:  1em;\n}\n\nh2.v-oldvotes-sub {\n    border-top:  2px solid silver;\n}\n\ndiv.helpHtml, .helpContent {\n    background: #eed;\n    font: medium Georgia, \"Times New Roman\", Times, serif;\n}\n\ndiv.helpHtml table {\n    border: 1px solid black;\n    border-collapse: collapse;\n}\n\ndiv.helpHtml td,div.helpHtml td th {\n    border: 1px solid black;\n    padding: 3px;\n}\n\n.graybox {\n\tborder: 1px solid gray;\n\tmargin: 3px;\n\tfont-size: small;\n}\n\n/* @group AJAX build */\n\n.d-sortmode {\n\tborder: 1px solid gray;\n\tbackground-color: #e3fbff;\n\tpadding: 0.2em 0.2em 0.2em 0.2em;\n\tmargin-top: 2px;\n\tfont-size: smaller;\n\tdisplay:  table;\n\tdisplay:  none;\n}\n\n#oldVotesAcceptList tr.subheading th{\n    text-align: left;\n    background-color: rgba(85, 193, 193, 0.58);\n}\n\nspan.pathChunk {\n    margin-right:  1em;\n    font: italic normal small Georgia, \"Times New Roman\", Times, serif;\n}\n\n#oldVotesAcceptList tbody tr td.v-path {\n    font-family: \"Courier New\", Courier, mono;\n    font-weight: bold;\n}\n\nspan.pathChunk:after\n{\n    content: ':';\n}\n\n.d-sortmode .d-sort-size0 {\n\tfont-size: x-large;\n\tpadding-left:  1em;\n\tbackground: url(warn.png) no-repeat left center;\n\tbackground-color: white;\n}\n\n.d-sortmode ul {\n\tdisplay: none; /* inline*/\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n \tmargin-left: 0;\n \tpadding-left:  0;\n}\n\n.d-sortmode li {\n\tdisplay: inline;\n\tmargin-left: 10px;\n}\n\n.d-sortmode li.notselected {\n\ttext-decoration: underline;\n\tcolor: blue;\n}\n\n.d-st-warn {\n\twidth: 16px;\n\theight: 16px;\n\tbackground: yellow url(warn.png) no-repeat center center;\n}\n\n.d-st-stop {\n\twidth: 16px;\n\theight: 16px;\n\tbackground: url(stop.png) no-repeat center center;\n}\n\n.d-st-okay {\n\twidth: 16px;\n\theight: 16px;\n}\n\n.d-dr-approved {\n\tcolor: green;\n}\n\n.d-dr-contributed,.d-dr-provisional,.d-dr-inherited-provisional {\n\tcolor: orange;\n}\n\n.d-dr-unconfirmed,.d-dr-inherited-unconfirmed {\n\tcolor: red;\n}\n\n.d-dr-missing {\n\tcolor: black;\n}\n\n.statuscell {\n\ttext-align: right;\n\tfont-family: emoji !important;\n\tfont-variant-emoji: emoji;\n}\n\n.voteDiv .winningStatus  {\n\tpadding-left: 20px;\n\tbackground-position: left !important;\n\twidth: inherit !important;\n}\n\n\n.voteDiv .lastReleaseStatus1 {\n    background: none !important;\n}\n\n.voteDiv .lastReleaseStatus0 {\n\tbackground: none !important;\n margin-left: 2em;\n}\n\n.voteInfo_key {\n\tpadding-left:  1em;\n}\n\nh3.voteInfo_key_title {\n\tmargin-bottom: .1em;\n}\n\n.d-code {\n    vertical-align: top;\n\tfont: bold small \"Courier New\", Courier, mono;\n}\n\n.d-disp {\n\tvertical-align: top;\n\tpadding-left:  2px;\n\tpadding-right:  2px;\n}\n\n.d-no-vo-false {\n    text-align: center;\n    background: #9999d0;\n}\n\n.d-no-vo-true {\n    text-align: center;\n}\n\n.d-no, .d-status {\n    width:  32px;\n}\n\n.d-item {\n\tdisplay:  inline-box;\n\tclear:both;\n}\n\n.d-item span span {\n     display:  inline !important;\n}\n\n#pu-content div.helpHtml {\n\tmargin-bottom:  0.5em;\n}\n\ntr.d-inforow, .d-item-selected {\n\tbackground-color: #eff;\n}\n\ntr.d-inforow td {\n\tpadding: 0.5em;\n\tborder-bottom: 3px solid gray;\n\tborder-left:  none;\n\tborder-right:  none;\n}\ntr.d-inforow td h3.span {\n\tfont-size: large;\n}\n\n.pu-select {\n\tborder: 2px double black !important;\n}\n\n.d-item-selected {\n\tborder: 2px solid navy;\n}\n\ntr.d-inforow-hid {\n\tdisplay: none;\n}\n\n.menu-o {\n    background: white url(rado.png) no-repeat center center;\n    width: 16px;\n    height: 16px;\n    margin-top: 5px;\n}\n\n.menu-zoom {\n    background: white url(zoom.png) no-repeat center center;\n    width: 16px;\n    height: 16px;\n    margin-top: 5px;\n}\n\n.menu-chat {\n    background: white url(chat.png) no-repeat center center;\n    width: 16px;\n    height: 16px;\n    margin-top: 5px;\n}\n\n.menu-x {\n    background: white url(radx.png) no-repeat center center;\n    width: 16px;\n    height: 16px;\n    margin-top: 5px;\n}\n\n.dijitMenuExpand {\n\tmargin-top: 5px !important;\n}\n\nbutton.ichoice-o {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: white url(rado.png) no-repeat center center;\n\tmargin: 1px;\n}\n\nbutton.ichoice-o:hover {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: url(rado.png) no-repeat center center;\n\tbackground-color: gray;\n\tmargin: 1px;\n}\n\nbutton.ichoice-o-okay {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: lime url(rado.png) no-repeat center center;\n\tmargin: 1px;\n\tborder: 2px solid green;\n}\n\nbutton.ichoice-o-okay:hover {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: url(rado.png) no-repeat center center;\n\tbackground-color: gray;\n\tmargin: 1px;\n}\n\nbutton.ichoice-x {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: white url(radx.png) no-repeat center center;\n\tmargin: 1px;\n}\n\nbutton.ichoice-x:hover {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: url(radx.png) no-repeat center center;\n\tbackground-color: gray;\n\tmargin: 1px;\n}\nbutton.ichoice-x-ok {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: url(radx.png) no-repeat center center;\n\tmargin: 1px;\n\topacity: 0.5;\n\tborder:  2px solid green;\n}\n\nbutton.ichoice-x-ok:hover {\n\twidth: 2em;\n\theight: 2em;\n\tbackground: url(radx.png) no-repeat center center;\n\tbackground-color: gray;\n\tmargin: 1px;\n}\n\nspan.i-override {\n\tfont-size: \tx-small;\n\tmargin-left: 0.25em;\n}\nspan.i-override, .voteInfo_overrideExplain {\n\tfont: \"Helvetica Neue\", Arial, Helvetica, Geneva, sans-serif;\n\tbackground-color: lime;\n\tcolor: navy;\n\tborder:  1px solid navy;\n\tpadding:  1px;\n}\nspan.i-override::before {\n\tcontent:  \"(\";\n}\nspan.i-override::after {\n\tcontent:  \"!)\";\n}\n\nbody.disconnected table.data button,\nbody.disconnected table.data input,\nbody.disconnected table.data .d-change,\nbody.disconnected table.data .d-change-err,\nbody.disconnected table.data .d-change-warn,\nbody.disconnected table.data .d-no,\nbody.disconnected table.data .d-no-vo-false,\nbody.disconnected table.data .d-no-vo-true {\n\tdisplay: none !important;\n}\n\nbutton#progress-refresh {\n    display: none;\n    bottom: 0.25em;\n    position: absolute;\n    right: 0.25em;\n    font-size: x-small;\n}\nbutton#progress-details {\n\tdisplay: block;\n    font-size: x-small;\n}\n\ntextarea.errorMessage {\n\tdisplay: block;\n\twidth: 100%;\n\theight: 10em;\n}\n\ndiv.possibleProblems {\n\tborder: 1px dashed olive;\n\tpadding: 0.2em;\n\tbackground-color: #FFFDD0;\n\toverflow: auto;\n}\n\ndiv.possibleProblems h3 {\n\tmargin:  0;\n}\n\ndiv.possibleProblems div {\n\tdisplay: block;\n}\n\ndiv.possibleProblems div p {\n\tmargin-top: .2em;\n\tmargin-bottom: .2em;\n\tpadding-left:  0.5em;\n\tfont-size:  larger;\n\tlist-style-type: square;\n\tdisplay:  list-item;\n\tlist-style-position: inside;\n}\n\ndiv.possibleProblems div p img {\n\tpadding-right:  0.25em;\n}\n\nbody.disconnected div#progress button#progress-refresh {\n\tdisplay: block !important;\n}\n\nbody.disconnected div#progress.progress-ok  button#progress-refresh {\n\tdisplay: none !important;\n}\n\ndiv#progress.progress-special,\ndiv#progress.progress-special span.oneword{\n\tfont-weight: bold;\n\ttext-decoration: none;\n}\n\ndiv#progress, div#progress span {\ntransition: background-color 0.2s;\n-moz-transition: background-color 0.2s;\n-webkit-transition: background-color 0.2s;\n-o-transition: background-color 0.2s;\n}\n\n.i-star {\n\tpadding: 2px;\n\twidth: 16px;\n\theight: 16px;\n\tbackground: url(star.png) no-repeat center center;\n}\n\n.i-star,.label-icon {\n\tposition:relative;\n\tleft:5px;\n\tdisplay:inline-block;\n\tvertical-align: middle;\n}\n\n.i-stop {\n\tpadding: 2px;\n\twidth: 17px;\n\theight: 17px;\n\tbackground: url(stop.png) no-repeat center center;\n}\n.i-warn {\n\tpadding: 2px;\n\twidth: 17px;\n\theight: 17px;\n\tbackground: url(warn.png) no-repeat center center;\n}\n.i-flag {\n\tpadding: 2px;\n\twidth: 17px;\n\theight: 17px;\n\tbackground: url(flag.png) no-repeat center center;\n}\n\n.s-flag {\n\twidth: 17px;\n\theight: 30px;\n\tbackground: url(flag.png) no-repeat center center ;\n}\n\ntd.d-change,td.d-change-err,td.d-change-warn {\n\twhite-space: nowrap;\n}\n\nbutton.d-inforow-hider {\n\tfloat: right;\n}\n\n.inputbox {\n\twidth: 75%;\n}\n\n.d-item,.d-item-warn,.d-item-err,\ntd.d-change,td.d-change-err,td.d-change-warn {\n\tvertical-align: top;\n\tmargin-top:-3px;\n}\n\ntd.d-change-err, td.d-win-err, .d-item-err {\n\tbackground: #fa9092 url(stop.png) no-repeat right top !important;\n}\n\n.d-item-err-noicon {\n\tbackground: #fa9092;\n}\n\ntd.d-change-confirmonly {\n\tbackground: #d9edf7;\n}\n\ntd.d-change-confirmonly .fnotebox {\n\tdisplay: block;\n\tborder: 0 !important;\n\tmargin-top: 0.5em;\n}\n\ntd.d-change-warn, td.d-win-warn, .d-item-warn {\n\tbackground: #fcf8e3 !important;\n}\n\ntd.d-win {\n}\n\n/* @end */\n\n/* @group Popup */\n\ndiv#pu-peak {\n\twidth: 11px;\n\theight:  16px;\n\t/*border:  1px solid green;*/\n\tbackground: #f8c871 none;\n\tposition: absolute;\n\tleft: 100px;\n\ttop: 10em;\n\topacity:  0.9;\n\tcolor: black;\n\tvertical-align: top;\n\ttext-align: right;\n\tz-index: 6;\n}\n\ndiv#pu-content {\n\tdisplay: none;\n\theight: 180px;\n\tpadding: 0.2em;\n\tpadding-bottom: 0;\n\tbox-shadow: 3px 3px 5px gray;\n\tborder:  2px solid #f8c871;\n\tpadding:  .5em;\n\tbackground-color: white;\n\tfont-size:  small;\n\toverflow: scroll;\n\tz-index: 6;\n\tposition: fixed;\n\tbottom: 12px;\n\tleft: 2em;\n\tright:  2em;\n}\n\n#pu-content h3.span {\n\tmargin-top:  0;\n\tmargin-bottom: 0;\n}\n\n/* @end */\n\n.anch,.anch-go {\n\tpadding: 5px;\n\tfont: small Georgia, \"Times New Roman\", Times, serif;\n}\n\n.recentList {\n\tdisplay: table;\n}\n\n.recentList div {\n\tdisplay: table-row;\n}\n\n.recentList div a,\n.recentList div b,\n.recentList div span {\n\tdisplay: table-cell;\n\tpadding: 2px;\n\tborder-bottom: 1px solid gray;\n}\n\n.recentList div b {\n\tbackground-color: #ddd;\n}\n\ndiv.voterList {\n\tdisplay:  block;\n}\n\ndiv.voterList .voterName {\n\tfont-weight: bold;\n\tdisplay:  inline;\n}\n\ndiv.voterList p {\n\tdisplay:  table-row;\n\tmargin-left:  0.25em;\n\tpadding-left:  20px;\n\tpadding-top: 0;\n\tmargin-top:0;\n\tmargin-bottom:  0.5em;\n}\n\n.rolloverspan:hover {\n\tcolor: white !important;\n\tbackground-color: navy !important;\n\ttransition: background-color 0.5s ease;\n}\n\nbutton.forumShow {\n    background: url(chat.png) no-repeat left center;\n    padding-left: 20px;\n}\n\nbody.claro > table#usertable,\nbody.claro > div#toparea,\nbody.claro > div#sectionmenu,\nbody.claro > div#footer {\n\tdisplay:  none;\n}\n\n#st-menubar  {\n    width: 40em;\n    display:  inline-block;\n}\n\n#borderContainer {\n\ttop:  0;\n    height: 100%;\n}\n\nspan.editableHere {\n    padding:  2px;\n}\n\n#oldVotesAcceptList th {\n    background-color: #ddd;\n}\n\n#oldVotesAcceptList tbody tr:hover {\n    background-color: #d7ca90;\n}\nth.v-accept a {\n    padding: .5em;\n    font-size: small;\n}\n\ntd.v-path {\n    white-space: nowrap;\n    font: small Georgia, \"Times New Roman\", Times, serif;\n    border:  1px solid black;\n    background-color:  white;\n}\n\n#revision-info {\n\tfont-size: x-small;\n\twhitespace: nowrap;\n}\n\n#oldVotesAcceptList {\n    border-collapse: collapse;\n}\n\n#oldVotesAcceptList td {\n    padding:  0.4em;\n    border-bottom:  1px solid gray;\n    vertical-align: bottom;\n}\n\n#title-item {\n    font-family: \"Courier New\", Courier, mono;\n    font-size: small;\n}\n\n.menu-container {\n    display:  inline;\n}\n\n.menu-container::before{\n    color:  black;\n}\n\n.menu-container:first-child:before {\n\tcontent: '';\n}\n/*\n  TODO: make this dynamic.\n  */\n.hideCov101 .cov101,\n.hideCov100 .cov100,\n.hideCov80 .cov80,\n.hideCov60 .cov60,\n.hideCov40 .cov40,\n.hideCov30 .cov30,\n.hideCov10 .cov10 {\n\tdisplay: none;\n}\n\n.hideCov101 .selectShow.cov101,\n.hideCov100 .selectShow.cov100,\n.hideCov80 .selectShow.cov80,\n.hideCov60 .selectShow.cov60,\n.hideCov40 .selectShow.cov40,\n.hideCov30 .selectShow.cov30,\n.hideCov10 .selectShow.cov10 {\n    display: table-row !important;\n    background-color: silver !important;\n}\n\n#LoadingMessageSection {\n    text-align: center;\n    padding-top:  3em;\n}\n\n#loginlink {\n    color:  maroon;\n    font-size: large;\n    font-weight: bold;\n}\n\n#ariHelp  {\n    float: right;\n}\n\n#ariMessage {\n    padding-left:  20px;\n    background: url(stop.png) no-repeat left top;\n    font-family: \"Lucida Grande\", Lucida, Verdana, sans-serif;\n    font-weight: bold;\n}\n\n.fakebutton {\n    border-style: outset;\n}\n\n#ariSub {\n    font: small \"Lucida Grande\", Lucida, Verdana, sans-serif;\n    margin-bottom: 0;\n}\n\n#ariScroller {\n    white-space: pre;\n    overflow: scroll;\n    font: small \"Courier New\", Courier, mono;\n    padding-left:  32px;\n    padding-top:  0;\n}\n\n.dijitDialogUnderlay, .claro .dijitDialogUnderlay {\n    opacity: 0.5 !important;\n    background-color: #b1b56a !important;\n}\n\n.mailListChunk, .mailContentChunk {\n    width: 48%;\n    display:  inline-block;\n    vertical-align: top;\n}\n\n.mailListChunk .loser {\n    border: 1px dashed red;\n    background-color: #fdd;\n}\n.mailListChunk .warning {\n    border: 1px solid yellow;\n}\n\n.mailContentChunk {\n    border:  1px solid gray;\n    padding:  0.5em;\n}\n\nh2.mailHeader {\n    margin: 0;\n    font: bold medium Georgia, \"Times New Roman\", Times, serif;\n}\n\np.mailContent {\n    line-height: 1em;\n    white-space: pre-line;\n}\n\n.mailListChunk li:hover {\n    background-color: gold;\n}\n\n.mailListChunk li.mailRow {\n    font-weight: bold;\n    list-style-type: decimal;\n}\n\n.mailListChunk li.mailRow.readMail {\n    font-weight: normal;\n}\n\n.st_setup_text {\n\tpadding: 0.5em;\n\tfont-size: large;\n}\n\nol.st_setup li {\n\tmargin-bottom: 1em;\n}\n\ndiv.st_setup  {\n\tfont-size: x-large;\n\tpadding: 1em;\n\tbackground-color: #ddf;\n}\n\n.bulkNextButton, .bulkNextInfo {\n\tposition: fixed;\n\tbottom: 1em;\n\tz-index: 50;\n}\n\n.bulkNextButton {\n\tright: 1em;\n\tmargin: 0.5em;\n\tpadding: 0.5em;\n}\n\ndiv.bulkNextButton {\n\tbackground-color: white;\n\tborder: 1px solid black;\n}\n\n.bulkNextInfo {\n\tleft: 1em;\n\tbackground-color: white;\n\tmargin: 0.5em;\n\tpadding: 0.25em;\n\tborder: 2px solid gray;\n}\n\n.bulkNextInfo ul {\n\tdisplay: table-row;\n\tmargin: 0;\n\tpadding:0 ;\n}\n\n.bulkNextInfo ul li {\n\tdisplay: table-cell;\n\ttext-align: center;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.bulkNextInfo ul li.active {\n\tcolor: black;\n\tbackground-color: lime;\n}\n\n.bulkNextInfo ul li.inactive {\n\tcolor: gray;\n}\n.bulkNextInfo ul li.inactive h2 {\n\tdisplay: none;\n}\n\n.bulkNextInfo li h1,\n.bulkNextInfo li h2 {\n\tpadding:0.25em;\n\tmargin:0.25em;\n}\n.bulkNextInfo li h1 {\n\tfont-size: large;\n}\n.bulkNextInfo li h2 {\n\tfont-size: smaller;\n}\n\n.bulkNextInfo ul li.active::before,\n.bulkNextInfo ul li.inactive::before {\n\tcontent: '»';\n}\n\ndiv.bulkInputForm {\n\tmargin: 1em;\n\tdisplay: table;\n}\n\ndiv.bulkInputForm div {\n\tdisplay: table-row;\n}\n\ndiv.bulkInputForm div input,\ndiv.bulkInputForm div label {\n\tdisplay: table-cell;\n\tmargin-left: 1em;\n}\n\n.infos-code {\n\tfloat:right;\n}\n\n.vsNav {\n\tpadding: .5em;\n\tborder-top: 2px solid gray;\n}\n\n.vsNav button {\n\tpadding: 2px;\n\tfont-size: larger;\n}\n\nspan.vsStatus {\n\tmargin-left: 1em;\n\tbackground-color: white;\n\tdisplay: block;\n}\n\n.vsContent.vsStale {\n\tcolor: gray;\n\tbackground-color: #dddddd;\n\topacity: .5;\n}\n\n.manage-list-icon {\n\tpadding-left: 0.25em;\n}\n\ntable.flaggedItems .codebox,\ntable.flaggedItems .adminUserUser {\n    display:  none;\n}\n\ntable.flaggedItems .r1 {\n    background-color: #f1fafa;\n}\n\ntable.flaggedItems th, table.flaggedItems td {\n    padding:  0.25em;\n}\n\ntable.flaggedItems .flaggedPath {\n    font-weight:  normal;\n}\n\n.flaggedItemsBox {\n    margin:  1em;\n}\n\n.special_flagged {\n\tdisplay:  table;\n}\n\n.special_flagged .flaggedLocaleHeader {\n\tdisplay:  table-row;\n\tbackground-color:  #fee;\n\tpadding-top:  4em;\n}\n\n.special_flagged h3 {\n\tpadding-left: 32px;\n\tbackground: url(flag.png) left center no-repeat;\n}\n\n.special_flagged div.flaggedItem {\n\tdisplay:  table-row;\n}\n.special_flagged div span {\n\tpadding-right:  .5em;\n}\n\n.special_flagged .flaggedLocaleHeader span {\n\tpadding-left:  1em;\n}\n\n.special_flagged div span,\n.special_flagged div .thinUser {\n\tdisplay:  table-cell;\n}\n\n.special_flagged .dateChunk {\n\tpadding-left:  1em;\n}\n\n.special_flagged .thinUser {\n\tmargin-left:  20px;\n}\n.special_flagged div .thinUser img {\n\tfloat:  left;\n}\n\n.special_flagged .thinUser .adminUserName {\n\tfont-size:  small;\n}\n\ndiv.thinUser {\n\tborder:  1px solid gray;\n\tborder-radius: .5em;\n\tpadding: 0.1em;\n}\n\n.special_flagged .pathHeaderInfo {\n\tfont-size:  smaller;\n\twhite-space: nowrap;\n}\n\n.followAlias {\n\tdisplay: block;\n}\n\n/* vetting participation */\n#vettingParticipation .locList {\n    display: block;\n    list-style: none;\n}\n\n#vettingParticipation .locRow {\n    display: block;\n}\n\n#vettingParticipation .locId {\n    display: block;\n    padding-right: 1em;\n    border: 1px solid gray;\n    border-top: 2px solid black;\n    font-size: larger;\n    margin-top: 1em;\n    padding-top: .25em;\n    background-color: lightgray;\n}\n\n#vettingParticipation .count {\n\tpadding-left: 1em;\n    font-size: smaller;\n    font-family: monospace;\n}\n\n#vettingParticipation .locId .count {\n\tfloat: right;\n}\n\n#vettingParticipation .missingLoc {\n    background-color: #f88;\n    margin-left: 5em;\n}\n\n#vettingParticipation .participatingUser {\n    border: 1px solid gray;\n     border-radius: .5em;\n     padding: .3em;\n     display: inline-flex;\n     width: 25em;\n}\n\n#vettingParticipation .participatingUser .userInfo {\n     width: 20em;\n\twhite-space: nowrap;\n}\n\n#vettingParticipation .participatingUsers {\n     display: block;\n    padding-top: 1em;\n    margin: 2em;\n }\n\n #vettingParticipation .vetter {\n     font-weight: bold;\n     padding: .1em;\n     background-color: rgb(181, 207, 199);\n }\n\n #vettingParticipation .noparticip {\n     color: red;\n     background-color: lightgoldenrodyellow !important;\n }\n\n.sidebyside-narrow a[href] {\n\tword-wrap: break-word;\n}\n\nfooter {\n\tmargin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
